import { ChangeDetectorRef, Component, ComponentFactoryResolver, HostListener, Input, OnInit, ViewChild, ViewContainerRef,  } from '@angular/core';
import { AspCustomerQuoteService } from './asp-customer-quote.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { GlobalVariable } from 'app/main/globals';
import { AspJobcardQuotationComponent } from '../asp-jobcard-quotation/asp-jobcard-quotation.component';
import { MyJobCardsDetailsService } from '../my-job-cards-details/my-job-cards-details.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AspRequestDetailsService } from '../asp-request-details/asp-request-details.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { AspQuotationDetailsService } from 'app/main/customer/asp-quotation-details/asp-quotation-details.service';
import { MyJobCardsDetailsComponent } from '../my-job-cards-details/my-job-cards-details.component';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 
import { privateDecrypt } from 'crypto';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { HttpClient} from "@angular/common/http";
import {SearchSuggestionService} from 'app/shared/search-suggestion.service'
import { AspProductDetailsService } from '../../auto-spare-parts/asp-product-details/asp-product-details.service';
import { AspCheckinReportsService } from '../asp-checkin-reports/asp-checkin-reports.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-asp-customer-quote',
  templateUrl: './asp-customer-quote.component.html',
  styleUrls: ['./asp-customer-quote.component.scss']
})
export class AspCustomerQuoteComponent implements OnInit {

  isVisible: boolean;
  isBottomSheetOpen = false;
  quoteShipping: any;
  resIds: any;
  data: any;
  email: string;
  phone: string;
  quoteId: any;
  resData: any;
  isPopupOpen = false;
  isApprovePopUpOpen=false;
  viewApprovePopUpOpen=false;
  selectedItems: any[];
  sidebarOpenQuote: boolean = false;
  requestDetails: any;
  customerQuotation: any = [];
  customerQuotationPrice: any = 0;
  item: any;
  regiNo: any;
  dataid: any;
  requestId: any;
  selectedItemsQuote: any[];
  selectedItemsCountQuote: any;
  totalSelectedPriceQuote: any;
  selectAllQuote:boolean = false;
  items: any;
  totalMRP: any;
  itemQuote: any = [];
  isPopupOpenEdit: boolean;
  successIcon: string;
  isMobile: boolean;
  isJobCardDetails: any;
  activeUrl: any;
  bookingId: any = 0;
  isEditLabourSidebarOpen: boolean = false;
  customerQuotation1: any;
  selectedItemsLabourQuote: any;
  // newly added properties
  type: string;
  loading: boolean;
  request: any;
  isSidebarOpen = false;
  searchText: string = '';
  filteredItems: any[] = [];
  searchWord: string = '';
  variantKey: string;
  partNumber: any;
  customerQuotationCount: any;
  selectedLaboursCount: any;
  labourListData: any[];
  filteredItems1: any[];
  selectedLabours: any[];
  selectedLabourslength: number;
  totallabourSelectedPrice: any;
  sparePartsTotal: number;
  selectedItemsCount: any;
  selectedLabourCount: number;
  isAddLabour = false;
  showSkipConfirmation = false;
  totalSelectedPriceQuote1: any;
   laborDetails: FormGroup;
  unitPrice: FormGroup;
  selectedLabour: any;
  labourName: any;
  labourAmount: any;
  labourId: any;
  id: any;
  showCancelConfirmation: boolean = false;
  totalSelectedPriceQuote2: any;
  totalapproveSelectedPriceQuote: any;
  totalSelectedLabourPriceQuote: any;
  totalSelectedApprovedriceQuote: any;
  selectitemsclick: any[];
  customerquoteId: any;
  totalApprovedItemsCount: any;
  itemsCount: any;
  editItemsCount: any;
  EdititemsCount: any;
  totalEditItemsCount: any;
  selectedItemsapprovedQuote: any;
  selectedItemsCountapprovedQuote: any;
  originalLabourQuotes: any[];
  totalEditSelectedPriceQuote: any;
  totalEditItemsPrice: any;
  totalSelectedEditPriceQuote: any;
  selectedItemsLabour: any;
  totalApprovingItemsCount: any;
  approvedItemsCount: any;
  selectedAlreadyApprovedQuote: any;
  selectedAlreadyApprovedQuotelength: any;
  selectedAlreadyApprovedQuoteLabourlength: number;
 @Input() QuoteId!: any;
@Input() jobcardId!:any;
@Input() pagetype: any;
  quoteItemStatus: any;
  selectAllLabourQuote: boolean;
  grageName: string;
  totallabourListSelectedPrice: any;
  labourQuotationPrice: number;
  estimatedTimeDeliveryValue: string = '';
  customerName: any;
  jobCardId: any;
  grandTotalApprovedAmount: any;
  grandLabourApprovedAmount: any;
  grandFinalApprovedTotalAmount: any;
  grandTotalApprovedViewAmount: any;
  grandLabourApprovedViewAmount: any;
  grandFinalApprovedViewTotalAmount: any;
  quoteGrandTotal: number;
  currentDate: Date = new Date();
  fullLabourList: any;
  finalDateTime: string | null = null;
  selectedTime: string | null = null;
  selectedDate: string;
  labourCount: number;
  labourCountNewList: any[];
  selectedLaboursNewCount: number;
  totallabourSelectedNewPrice: any;
  editCustomerQuotation: any;
  editLabourItemsLabourQuote: any;
  editLabourItemsLabourQuote1: any;
  editSelectedItemsQuote: any;
  editSelectedQuoteLength: any;
  editlabourlength: any;
  totalEditCount: any;
  selectedEditQuote: any;
  approvedQuotationLength: any;
  totalEditQuoteItemsCount: any;
  newlyUploadedImages: any[];
  selectedImageUrls: string[] = [];
  images: any;
  link: any;
  newlyUploadedLength: number = 0;
  currentIndex = 0;
  currentTag: string = '';
  selectedImage: string = '';
  isViewerOpen: boolean = false;
  updatedImages: any;
  finalImages: any;
  updateImage: any[];
  deleteUpdatedImage: any[];
  finalImagesLength: any;
  quotationImages: any;
  quotationImagesLength: any;
    newItem: boolean;
    newItems: boolean;
    itemForm: FormGroup;
    gstOptions: number[] = [5, 12, 18, 28]; 
    originalData: any;
  customerQuotationListCount: any;
  showExtraDiscountBottomSheet = false;
  discountType: 'rupees' | 'percentage' | null;
  discountValue: number | null | 0.0;
  showInfoPopup: boolean = false;
  discountInRupees: number = 0;
  discountInPercent: number = 0;
  calculatedDiscount: number = 0;
  getDiscount: any;
  isDiscountInvalid: boolean;
  searchActive: boolean = false;
  itemSuggestions: any[] = [];
  showSuggestionList = false;
  suggestions: { value: string; type: string }[] = []; // Updated type
  selectedSuggestions: Set<string> = new Set<string>();
  isInputVisible = false;
  isSearchOpen = false;
  searchTimeout: any;
  selectedGst: number | null = null;
  carSize: any;
  rateCardApplicable: any;
  status: number;
  mainForm: FormGroup;
  quoteFormArray: FormArray;
  itemDiscountType: any;
  itemDiscountValue: any;
  labourjobCardStatus: number;

  constructor(
    public searchSuggestionService:SearchSuggestionService,
    private aspProductDetailsService: AspProductDetailsService,
    private aspCustomerQuoteService:AspCustomerQuoteService,
    private resolver: ComponentFactoryResolver,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private myJobCardsDetailsService:MyJobCardsDetailsService,
    private aspRequestDetailsService: AspRequestDetailsService,
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private aspQuotationDetailsService: AspQuotationDetailsService,
    private aspLoadingService: AspLoadingService,
    private s3ImageUploadService: S3ImageUploadService,
     private http: HttpClient,
     private fb: FormBuilder,
    private aspCheckinReportsService:AspCheckinReportsService,
        private location: Location,  
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); 

    this.itemForm = new FormGroup({
      itemName: new FormControl('', Validators.required),
      partNumber: new FormControl('', Validators.required),
      brand: new FormControl('', Validators.required),
      hsn: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{4,8}$')]), // HSN validation (4-8 digits)
      gst: new FormControl('', Validators.required), // Dropdown selection required
    
    
      unitPrice: new FormControl('', [Validators.required, Validators.min(0)]) // Unit price must be > 0
    });
  
  }

  openSidebarQuote(): void {
    this.clearOldData(); 
    this.getQuoteDetails();
    this.getRequestDetails();
    this.sidebarOpenQuote = true; 
    this.closeSidebar(true);
    this.closeMenu();
    this.submitDataUpdate();  
    
  }
      // @ViewChild('dynamicContainer1', { read: ViewContainerRef }) container1!: ViewContainerRef;
      // @ViewChild('dynamicContainer2', { read: ViewContainerRef }) container2: ViewContainerRef;  
      // approveQuote(type=''): void {
      //   // const factory = this.resolver.resolveComponentFactory(AspJobcardQuotationComponent);
      //   // const componentRef = this.container2.createComponent(factory);
      //   // const componentInstance = componentRef.instance as AspJobcardQuotationComponent;
      //   // // componentInstance.ngOnInit();
      //   // componentInstance.setActiveTabs('quotation',type,this.jobcardId,this.bookingId,this.quoteId);
      //   // this.closePopup();
      //   this.isEditLabourSidebarOpen = true;
      // }
  clearOldData(): void {
    this.customerQuotation = []; 
    this.sidebarOpenQuote = false;
    this.customerQuotationPrice=0;
    this.selectAllQuote=false;
    this.selectedItemsCountQuote=[];
}
  CloseSidebarQuote(): void {
    this.sidebarOpenQuote = false;    
    this.type = '';
    this.isVisible = true; 
  }
  viewPopUp(){
    
    this.viewApprovePopUpOpen=true;
    this.sidebarOpenQuote=false;
    this.currentDate = new Date();
    // Update every second (optional, if you want dynamic updates)
setInterval(() => {
this.currentDate = new Date();
}, 1000);
  
  }
  sendUpdateApproval(){
    this.isEditLabourSidebarOpen = true;
    
  }
  formatTime12Hour(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }
  
  
  sendUpdate(): void {
    this.isEditLabourSidebarOpen = false;
    let garageName = localStorage.getItem('spareSelectedGarageName');
  
    let completedItems = this.customerQuotation1
      .filter(item => item.quoteItemStatus === 1)
      .map(item => `${item.itemName}`);
    let completedLabours = this.selectedItemsLabour
      .filter(labour => labour.quoteItemStatus === 1)
      .map(labour => `${labour.labourName}`);
    let pendingItems = this.customerQuotation1
      .filter(item => item.quoteItemStatus === 2)
      .map(item => `${item.itemName}`);
    let pendingLabours = this.selectedItemsLabour
      .filter(labour => labour.quoteItemStatus === 2)
      .map(labour => `${labour.labourName}`);
  
    let completedWorkSection = completedItems.length || completedLabours.length
      ? `✅*Completed Work*:\n${completedItems.concat(completedLabours).join('\n')}\n\n`
      : '';
  
    let pendingWorkSection = pendingItems.length || pendingLabours.length
      ? `🔄*Pending Work*:\n${pendingItems.concat(pendingLabours).join('\n')}\n\n`
      : '';
  
    // Format time to 12-hour format
    let formattedTime = this.selectedTime
      ? this.formatTime12Hour(this.selectedTime)
      : '';
  
    // Build ETA message
    let etaMessage = '';
    if (this.selectedDate && formattedTime) {
      etaMessage = `🕒ETA for Delivery: Your car will be ready *${this.selectedDate}* at *${formattedTime}*\n\n`;
    } else if (this.selectedDate) {
      etaMessage = `🕒ETA for Delivery: Your car will be ready *${this.selectedDate}*\n\n`;
    } else if (formattedTime) {
      etaMessage = `🕒ETA for Delivery: Your car will be ready at *${formattedTime}*\n\n`;
    }
  
    const message = `📢 Car Service & Repair Update\n\n` +
      `Dear ${this.customerName},\n\n` +
      `We would like to update you about the progress of your service:\n\n` +
      `${completedWorkSection}` +
      `${pendingWorkSection}` +
      `${etaMessage}` +
      `Thank you for choosing *${garageName}*! We appreciate your business. If you have any questions, feel free to reach out.\n\n` +
      `Best regards,\n*${garageName}* Team 🙏`;
  
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  
    this.laborDetails.reset();
    this.closeMenu();
    
  }
  






  ngOnInit(): void {
    this.activeUrl = this.router.url;
    this.isJobCardDetails = this.activeUrl.includes('/my-job-cards-details');
    this.email = localStorage.getItem('contactEmail');
    this.phone = localStorage.getItem('contactPhone');
    this.grageName = localStorage.getItem('spareSelectedGarageName');
    this.successIcon = '../../../../assets/icons/icons8-ok.gif';

    this.laborDetails = this._formBuilder.group({
      labourName: ['', [Validators.required, Validators.minLength(2)]], 
      labourAmount: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      estimatedTimeDelivery: [''],
      estimatedTime: ['']
    });
    this.unitPrice=this._formBuilder.group({
      unitprice:['',[Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
     this.quoteFormArray = this.fb.array([]);
    this.mainForm = this.fb.group({
      quoteFormArray: this.quoteFormArray
    });
      this.selectAllQuote = false;

      this.getQuoteDetails();

      let activeTabData = JSON.parse(localStorage.getItem('activeTab'));
    if(activeTabData.name == 'quotation' && activeTabData.type=='edit'){
      this.openSidebarQuote1('edit', '1');            
      localStorage.removeItem('activeTab');
    }
      const formArray = this.mainForm.get('quoteFormArray') as FormArray;

      formArray.controls.forEach((group, index) => {
        const discountPercentage = +group.get('discountPercentage')?.value || 0;
        if (discountPercentage > 0) {
          this.onDiscountPercentageInput(index);
        }
      });

      if(this.pagetype=='request_page'){
        this.isJobCardDetails = true;
      }
    
  }
  
  closeSidebar(ishide: boolean) {
    this.isVisible = ishide;
    // this.loadOrderDetails();
    
    // this.getQuoteDetails();
    
  }
  opendetais(){
    // this.closeSidebar(true);
    this.loadOrderDetails();
    // this.closePopup();
    
  }
  openMenu() {
    this.isBottomSheetOpen = true;
    
  }
//   updateEstimatedTime(selectedDate: Date) {
//     if (selectedDate) {
//         this.estimatedTimeDeliveryValue = selectedDate.toISOString(); // Store in ISO format
        // console.log("Selected Estimated Time Delivery:", this.estimatedTimeDeliveryValue);
//     }
// }
// Combine Date & Time when submitting
// updateEstimatedTime(event: any) {
//   const dateObj = event instanceof Date ? event : this.laborDetails.value.estimatedTimeDelivery;
//   const time = this.laborDetails.value.estimatedTime;

//   if (!dateObj) {
//     console.warn("Date is missing!");
//     return;
//   }

//   // ✅ Extract only YYYY-MM-DD from Date object
//   const formattedDate = this.formatDate(dateObj);
//   console.log("Selected Date (Formatted):", formattedDate);

//   if (time) {
//     const [hours, minutes] = time.split(':');
//     const finalDateTime = new Date(dateObj);
//     finalDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10));

//     // ✅ Format final output as "YYYY-MM-DD HH:mm"
//     this.finalDateTime = `${formattedDate} ${hours}:${minutes}`;
//     console.log('Final Selected DateTime:', this.finalDateTime);
//   } else {
//     this.finalDateTime = `${formattedDate}`; // Store only date if time is missing
//   }
// }

// formatDate(date: Date): string {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
//   const day = String(date.getDate()).padStart(2, '0');

//   return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
// }


// formatDateTime(date: Date): string {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
//   const day = String(date.getDate()).padStart(2, '0');
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');

//   return `${year}-${month}-${day} ${hours}:${minutes}`;
// }



updateEstimatedTime(event: any) {
  const dateObj = event instanceof Date ? event : this.laborDetails.value.estimatedTimeDelivery;
  const time = this.laborDetails.value.estimatedTime;

  if (!dateObj) {
    // console.warn("Date is missing!");
    return;
  }

  // ✅ Extract only YYYY-MM-DD from Date object
  this.selectedDate = this.formatDate(dateObj);
  // console.log("Selected Date:", this.selectedDate);

  if (time) {
    const [hours, minutes] = time.split(':');
    this.selectedTime = `${hours}:${minutes}`;
    // console.log("Selected Time:", this.selectedTime);

    // ✅ Combine date & time if both exist
    this.finalDateTime = `${this.selectedDate} ${this.selectedTime}`;
    // console.log('Final Selected DateTime:', this.finalDateTime);
  } else {
    this.selectedTime = null;
    this.finalDateTime = this.selectedDate; // Store only date if time is missing
  }
}

formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
}




  resId(id){
    this.resIds=id;
  }
  regNo(regNo){
    this.regiNo=regNo;
  }
  closeMenu(): void {
    this.isBottomSheetOpen = false;
  }


  async downloadPDF() {
    this.aspLoadingService.show();
    // Import html2pdf dynamically
    const html2pdf = await import('html2pdf.js');
    
    // Reference the container element
    const element = document.getElementById('quotationContent');
    
    if (!element) {
      console.error('Element not found!');
      return;
    }

    // Options for PDF generation
    const options = {
      margin: 0.3,
      filename: 'quotation.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };


    html2pdf.default().from(element).set(options).save();
    this.aspLoadingService.hide();
  }
  openSidebarQuote1(type='', request=''): void {
    // this.ngOnInit();
    this.type=type;
    this.isBottomSheetOpen=false;
    this.closeSidebar(false);
    this.sidebarOpenQuote = true; 
    this.getJobcardDetails();
    if(request!='1'){
      this.getQuoteDetails();
    }
      setTimeout(() => {
        const formArray = this.mainForm.get('quoteFormArray') as FormArray;

        if (formArray && formArray.controls?.length > 0) {
          formArray.controls.forEach((control, i) => {
            const discountPercentage = +control.get('discountPercentage')?.value || 0;
            const discountValue = +control.get('discountValue')?.value || 0;

            // Prefer percentage input if both are filled, else use available
            if (discountPercentage > 0) {
              this.onDiscountPercentageInput(i);
            } else if (discountValue > 0) {
              this.onDiscountValueInput(i);
            }
          });
        }
      }, 0);
    this.getQuoteGrandTotal();
    this.grandApprovedTotal();
    this.grandTotal();
    
    this.isPopupOpen=false;
    this.isApprovePopUpOpen=false;
    if(type=='edit'){
      this.selectAllQuote = false;
    }
    if(type == 'approve')
    {
      this.selectAllQuote = false;
    }
    if(type == 'view')
    {
      this.selectAllQuote = false;
    }



  }
  closeSidebar1(){
    this.isPopupOpen = false;
    // this.loadOrderDetails();
    this.closeSidebar(true);
    this.getQuoteDetails();
    this.submitDataUpdate();
   

  }
  markAsCompleteUpdate() {
    let itemData = [];
    let allItemsCompleted = true; // Track if all items are marked as complete
    // console.log("all items---=----",this.customerQuotation1);
    // console.log("this.selectedLabour---",this.selectedItemsLabour)
    this.customerQuotation1.forEach(approved => {
        if (approved.selected == 'true' || approved.selected == true) {
            itemData.push({ "id": approved.itemId, "quoteItemStatus": 1 });
        }
        if (approved.quoteItemStatus !== 1) {
            allItemsCompleted = false; 
        }
    });

    let labourItems = [];
    this.selectedItemsLabour.forEach(approved => {
        if (approved.selected == 'true' || approved.selected == true) {
            labourItems.push({ "labourName": approved.labourName, "quoteItemStatus": 1 });
        }
        if (approved.quoteItemStatus !== 1) {
            allItemsCompleted = false; 
                  }
    });

    let param = {
        "jobcardId": this.jobcardId,
        "customerQuoteId": this.customerquoteId,
        "customerQuoteItems": itemData,
        "labourQuoteItems": labourItems,
        
    };

    this.aspCustomerQuoteService.markAsComplete(param).subscribe(response => {
        this.getQuoteDetails();
        this.viewPopUp();
        // console.log("all items completed---",allItemsCompleted)
        if (allItemsCompleted) {
            const approvalElement = document.getElementsByClassName('approval-due')[0] as HTMLElement;
            if (approvalElement) {
                approvalElement.innerHTML = "Ready";
                approvalElement.style.backgroundColor = "#3f9943";
            }
        }
    });
}

  labourSideOpen()
  {
    this.sidebarOpenQuote=true;

    this.isEditLabourSidebarOpen = true;
    this.viewApprovePopUpOpen=false;
  }
  AddItems()
  {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.searchText = '';
    this.filteredItems = [];
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  onSearch(item: any) {
    if (!this.searchWord.trim()) {
      return;
    }
    const garageKey=localStorage.getItem('garageKey');
    this.variantKey=localStorage.getItem('VariantKey');
    // if( this.isRequestDetails){
    //  this.variantKey=localStorage.getItem('VariantKey');
    //  console.log("this.isRequestDetails",this.variantKey)
    // }
    if ( this.isJobCardDetails){
      // this.variantKey=this.jobCard['variantKey'];
      this.variantKey=localStorage.getItem('VariantKey');
      // console.log("this.isJobCardDetails",this.variantKey)
    }

    this.aspRequestDetailsService
      .searchItems(garageKey, this.searchWord, this.variantKey)
      .subscribe(
        (result) => {
          const res = JSON.parse(JSON.stringify(result));
          
          if (res.code === 200) {
            // console.log('Search results:', res.data);
            this.filteredItems = res.data;
            this.partNumber= res.data.map((item: any) => item.partNumber);
          } else {
            console.error('Search failed with code:', res.code);
          }
        },
        (error) => {
          console.error('Error during search:', error);
        }
      );
  }
  clearSearch() {
    this.searchWord = '';
  
    this.filteredItems = [];
  }


//   addItemToQuotation(item: any) {
//     // console.log('Attempting to add item:', item);
//     // console.log('Current customerQuotation list:', this.customerQuotation);
//     this.customerQuotationCount = this.customerQuotation.length;
//     // console.log("customerquotecount-------------", this.customerQuotationCount);

//     // Find an existing item with the same partNumber
//  const existingItemIndex = this.customerQuotation.findIndex(quote => quote.partNumber === item.partNumber);

// if (existingItemIndex !== -1) {
//     // Update quantity
//     const existingItem = this.customerQuotation[existingItemIndex];
//     existingItem.quantity += 1;
//     existingItem.selected = true;

//     // ✅ Ensure a form group exists in quoteFormArray at this index
//     if (!this.quoteFormArray.at(existingItemIndex)) {
//         const discountGroup = this.fb.group({
//           discountValue: this.itemDiscountType || [0],
//           discountPercentage: this.itemDiscountValue || [0]
//         });


//         discountGroup.valueChanges.subscribe(discount => {
//           this.recalculateMrpWithDiscount(existingItemIndex, discount);
//         });

//         this.quoteFormArray.insert(existingItemIndex, discountGroup);
//     }

// } else {
//     // New item logic
//     const newItem = {
//         itemId: item.itemId,
//         itemName: item.name,
//         brand: item.brand,
//         partNumber: item.partNumber,
//         sellingPrice: item.mrp,
//         mrp: item.mrp,
//         originalMrp: item.mrp,
//         gstRate: item.gstRate,
//         hsnCode: item.hsnCode,
//         quantity: 1,
//         selected: true,
//         edt: new Date(),
//         jobCardStatus: 2
//     };

//     this.customerQuotation.push(newItem);

//     const discountGroup = this.fb.group({
//       discountValue: this.itemDiscountType || [0],
//       discountPercentage: this.itemDiscountValue || [0]
//     });

//     discountGroup.valueChanges.subscribe(discount => {
//       const itemIndex = this.customerQuotation.length - 1;
//       this.recalculateMrpWithDiscount(itemIndex, discount);
//     });

//     this.quoteFormArray.push(discountGroup);
// }


//     // Ensure all items maintain the correct selection state
//     // this.customerQuotation.forEach(quote => quote.selected = true);

//     this.isSidebarOpen = false;
    
//     this.clearSearch();
//     this.updateSelectedItemsQuote();
//     this.getQuoteGrandTotal();
//     // this.sidebarToggleSelectAllQuote();

// }
addItemToQuotation(item: any) {
  this.customerQuotationCount = this.customerQuotation.length;

  const existingItemIndex = this.customerQuotation.findIndex(quote => quote.partNumber === item.partNumber);

  if (existingItemIndex !== -1) {
    const existingItem = this.customerQuotation[existingItemIndex];
    existingItem.quantity += 1;
    existingItem.selected = true;

    if (!this.quoteFormArray.at(existingItemIndex)) {
      const discountGroup = this.fb.group({
        discountValue: [0],
        discountPercentage: [0]
      });

      discountGroup.valueChanges.subscribe(discount => {
        this.recalculateMrpWithDiscount(existingItemIndex, discount);
      });

      this.quoteFormArray.insert(existingItemIndex, discountGroup);
    }

  } else {
    const newItem = {
      itemId: item.itemId,
      itemName: item.name,
      brand: typeof item.brand === 'object' ? item.brand.name : item.brand,
      partNumber: item.partNumber,
      sellingPrice: item.sellingPrice,
      mrp: item.mrp,
      originalMrp: item.mrp,
      gstRate: item.gstRate,
      hsnCode: item.hsnCode,
      quantity: 1,
      selected: true,
      edt: new Date(),
      jobCardStatus: 2
    };

    this.customerQuotation.push(newItem);

    const discountGroup = this.fb.group({
      discountValue: [0],
      discountPercentage: [0]
    });

    discountGroup.valueChanges.subscribe(discount => {
      const itemIndex = this.customerQuotation.length - 1;
      this.recalculateMrpWithDiscount(itemIndex, discount);
    });

    this.quoteFormArray.push(discountGroup);
  }

  this.isSidebarOpen = false;
  this.clearSearch();
  this.updateSelectedItemsQuote();
  this.getQuoteGrandTotal();
}


grandApprovedTotal()
{
  this.getQuoteDetails();
  this.grandTotalApprovedViewAmount = this.customerQuotation1?.filter(quote=>quote).reduce((total, quote) => total + (quote.sellingPrice * quote.quantity), 0);
// console.log("saikiran item---",this.grandTotalApprovedViewAmount);
  this.grandLabourApprovedViewAmount = this.selectedItemsLabour?.reduce((sum, labour) => {
    return sum + (Number(labour.labourAmount) * Number(labour.quantity || 1) || 0);
  }, 0);
  // console.log("saikiran item approved ---",this.grandTotalApprovedViewAmount);
  // console.log("saikiran Labour approved---",this.grandLabourApprovedViewAmount);
  this.grandFinalApprovedViewTotalAmount=(this.grandTotalApprovedViewAmount || 0)+(this.grandLabourApprovedViewAmount || 0);
  // console.log("saikiran price view price ------",this.grandFinalApprovedViewTotalAmount)

}
getQuoteGrandTotal(){
  let partsTotal = 0;
  if(this.customerQuotation){
    partsTotal = this.customerQuotation?.reduce((sum, item) => sum + (item.mrp * item.quantity),0);
  }
  if (this.editCustomerQuotation && !this.customerQuotation || this.customerQuotation){
    partsTotal = this.editCustomerQuotation?.reduce((sum, item) => sum + (item.mrp * item.quantity),0);
    // console.log("parts total--",partsTotal)
  }
  let labourTotal = 0;
  if(this.selectedItemsLabourQuote){
    labourTotal = this.selectedItemsLabourQuote?.reduce((sum, item) => sum + (Number(item.labourAmount) * item.quantity),0);
  }
  if(this.editLabourItemsLabourQuote){
    labourTotal = this.editLabourItemsLabourQuote?.reduce((sum, item) => sum + (Number(item.labourAmount) * item.quantity),0);
  }
  this.quoteGrandTotal = ((partsTotal || 0) + (labourTotal || 0));
}  

grandTotal(){
  this.grandTotalApprovedAmount = this.customerQuotation
  .filter(quote=>quote)
  .reduce((total, quote) => total + (quote.sellingPrice * quote.quantity), 0);
  this.selectedLabours = this.selectedItemsLabourQuote?.filter(labour => labour.selected);
  this.grandLabourApprovedAmount = this.selectedItemsLabourQuote.reduce((sum, labour) => {
    return sum + (Number(labour.labourAmount) * Number(labour.quantity || 1) || 0);
  }, 0);
  // console.log("this.selectedItemsLabourQuote---",this.grandLabourApprovedAmount);
  this.grandFinalApprovedTotalAmount=(this.grandTotalApprovedAmount || 0)+(this.grandLabourApprovedAmount || 0);
  // console.log("saikiran price ------",this.grandFinalApprovedTotalAmount)

}

     getJobcardDetails() {
            this.aspLoadingService.show();
            const garageKey = localStorage.getItem('garageKey');
            // console.log("this.jobCardIdDFKJFHFDFHUFDFHUFDHFD--", this.jobcardId);
            this.aspCustomerQuoteService.getJobCardDetails(this.bookingId , garageKey, this.jobcardId).subscribe(
              (result: any) => {
                this.aspLoadingService.hide();
          
                if (result && result.code === 200) {
                  this.request = result.data;
                  // this.fetchPreFilledBooking();
                  if (this.request?.jobCard) {
                    this.customerName = this.request.jobCard.name;
                    // console.log("this.customerNmae---",this.customerName)
                    this.jobCardId = this.request.jobCard.jobCardId;
                    this.customerquoteId = this.request.jobCard.customerQuoteId;
                    this.carSize = this.request.jobCard.carSize;
                    this.rateCardApplicable = this.request.jobCard.rateCardApplicable;
                    // console.log("this.customerQuoteId:", this.customerquoteId);
                  } else {
                    console.error("Error: jobCard is undefined in this.request", this.request);
                  }
                  const requestId = this.request?.jobCard?.requestId;
                } else {
                  this.aspLoadingService.hide();
                }
              },
              (error: HttpErrorResponse) => {
                this.aspLoadingService.hide();
              }
            ); 
      }
addEditItemToQuotation(item: any) {
  this.customerQuotationCount = this.editCustomerQuotation.length;
  const existingItem = this.editCustomerQuotation.find(quote => quote.partNumber === item.partNumber);

  if (existingItem) {
      // If found, increase the quantity and ensure it's selected
      existingItem.quantity += 1;
      existingItem.selected = true;
      // console.log('Item already exists, increased quantity:', existingItem);
  } else {
      const newItem = {
          itemId: item.itemId,
          itemName: item.name,
          brand: item.brand,
          partNumber: item.partNumber,
          sellingPrice: item.sellingPrice,
          mrp: item.mrp,
          // originalMrp: item.mrp,
          gstRate:item.gstRate,
          hsnCode:item.hsnCode,
          quantity: 1,
          selected: true,
          jobCardStatus : 3
      };
      this.editCustomerQuotation.push(newItem);
      // console.log('Item added successfully:', newItem);

      

const discountGroup = this.fb.group({
   discountValue: [0],
   discountPercentage: [0]
});


    discountGroup.valueChanges.subscribe(discount => {
      const itemIndex = this.editCustomerQuotation.length - 1;
      this.recalculateMrpWithDiscount(itemIndex, discount);
    });

    this.quoteFormArray.push(discountGroup);
  }
  // Ensure all items maintain the correct selection state
  // this.editCustomerQuotation.forEach(quote => quote.selected = true);

  this.isSidebarOpen = false;
  
  this.clearSearch();
  this.updateSelectedEditItemsQuote();
  this.updateEditSelectedLabourItems();
  this.getQuoteGrandTotal();
  this.anyItemEditSelected();

}
  
  getQuoteDetails() {  
     
    const userKey = localStorage.getItem('spareUserKey');
    const garageKey = localStorage.getItem('garageKey');
    this.quoteId = this.QuoteId? this.QuoteId : this.resIds;
    this.aspCustomerQuoteService.getQuoteDetails(garageKey, this.quoteId, userKey,this.jobcardId,this.bookingId).subscribe(
      result => {
        const res = JSON.parse(JSON.stringify(result));
        // this.getDiscount = res;
        // console.log("getDiscount-------",this.getDiscount);
        this.data = res.data;
        // console.log("quote details----",this.data)
        this.editCustomerQuotation = (this.data.items || []);
        this.editCustomerQuotation.forEach(quote => {
          if (!quote.originalMrp) {
            quote.originalMrp = quote.mrp;
          }
      });

      // console.log("this.editCustomerQuotation-----",this.editCustomerQuotation);
      if(this.editCustomerQuotation)
      {

        setTimeout(() => {
          const formArray = this.mainForm.get('quoteFormArray') as FormArray;

          if (formArray && formArray.controls?.length > 0) {
            formArray.controls.forEach((control, i) => {
              const discountPercentage = +control.get('discountPercentage')?.value || 0;
              const discountValue = +control.get('discountValue')?.value || 0;

              if (discountPercentage > 0) {
                this.onDiscountPercentageInput(i);
              } else if (discountValue > 0) {
                this.onDiscountValueInput(i);
              }
            });
          }
        }, 0);

      }


          if (localStorage.getItem('requestedQuoteItems')) {
  let requestedQuoteItems = JSON.parse(localStorage.getItem('requestedQuoteItems')) || [];

  requestedQuoteItems.forEach((quoteItem, index) => {
    this.editCustomerQuotation.push(quoteItem);
    this.customerQuotation.push(quoteItem); // ✅ add to customerQuotation too

    const isPercentage = quoteItem.discountType === 'percentage';
    const group = this.fb.group({
      discountValue: [!isPercentage ? quoteItem.discountValue : null],
      discountPercentage: [isPercentage ? quoteItem.discountValue : null]
    });

    group.valueChanges.subscribe(discount => {
      const formIndex = this.quoteFormArray.length; // use index based on push order
      this.recalculateMrpWithDiscount(formIndex, discount);
    });

    this.quoteFormArray.push(group); // ✅ push new control to FormArray
  });
}


          // console.log("edit customer quotation--",this.editCustomerQuotation)
          
          // console.log("edit customer Quotation data---",this.editCustomerQuotation);
          this.EdititemsCount  = (this.data.items || []);
          this.customerQuotation1 = (this.data.items || []).filter(item => item.jobCardStatus === 4);
          this.quoteItemStatus= (this.customerQuotation1||[]).filter(item => item.quoteItemStatus== 2|| item.quoteItemStatus=='2');
          this.editItemsCount=(this.data.items || []).filter(item => item.jobCardStatus === 3 || item.jobCardStatus === '3').length;
          this.customerQuotation = (this.data.items || []).filter(
            item => item.jobCardStatus === 3
          );
            this.customerQuotation = (this.data.items || []).filter(
              item => item.jobCardStatus === 3
            ).map(item => {
              const mrp = item.originalMrp ?? item.mrp ?? 0;
              const discountType = item.discountType;
              const discountValue = item.discountValue ?? 0;
              

              let discountAmount = 0;

              if (discountType === 'percentage') {
                discountAmount = (mrp * discountValue) / 100;
              } else if (discountType === 'rupees') {
                discountAmount = discountValue;
              }

              const finalMrp = mrp - discountAmount;

              return {
                ...item,
                discountType,
                discountValue,
                discountedMrp: finalMrp >= 0 ? finalMrp : 0,
                isDiscountInvalid: discountAmount > mrp
              };
            });





          // console.log("approved quotation o statis 4----",this.customerQuotation1);
          this.approvedQuotationLength =this.customerQuotation.length;
          // console.log("this customerQuotation---",this.customerQuotation);
          this.selectedItemsLabourQuote = (this.data.labourQuoteItemResponses || []).filter(labour => labour.jobCardStatus === 3 || labour.jobCardStatus === '3');
          this.selectedItemsLabour=(this.data.labourQuoteItemResponses || []).filter(labour => labour.jobCardStatus >= 4 || labour.jobCardStatus >= '4');
          // console.log("approve labours for status 4---",this.selectedItemsLabour);
          this.editLabourItemsLabourQuote = (this.data.labourQuoteItemResponses || []);
          // console.log("edit labour list for jobcardstatus ------",this.editLabourItemsLabourQuote);
          this.approvedItemsCount=(this.data.items || []).filter(item => item.jobCardStatus === 4 || item.jobCardStatus === '4').length;
          const labourItemsCount = (this.data.labourQuoteItemResponses || []).length;
          this.totalApprovedItemsCount=(this.approvedItemsCount | 0)+(this.selectedItemsLabour.length | 0);
          this.totalApprovingItemsCount = (this.approvedQuotationLength) + ( this.selectedItemsLabourQuote.length | 0);
          this.totalEditItemsCount=(this.EdititemsCount)+(this.selectedItemsLabourQuote?.length || 0);
          // console.log("this.updatedImagesLength----",this.updatedImages);
          this.data.quotationImages = Array.isArray(this.data.quotationImages) ? this.data.quotationImages : [];
          this.updatedImages = Array.isArray(this.updatedImages) ? this.updatedImages : [];
          // console.log("this.updatedImages before merging:", this.updatedImages);
          this.quotationImages = [...this.data.quotationImages, ...this.updatedImages];
          // console.log("Final quotationImages:", this.quotationImages);
          this.quotationImagesLength = this.quotationImages.length;
          this.discountType = this.data?.discountType ? this.data.discountType : '';
          this.discountValue = this.data?.discountValue ? this.data.discountValue : 0;
          // console.log("this.discountType",this.discountType);
          // console.log("this.discountValue",this.discountValue);
          this.itemDiscountType = this.data.items[0]?.discountType || '';
          this.itemDiscountValue = this.data.items[0]?.discountValue || 0;
          // console.log("his.itemDiscountType = this.data.items.discountType ? this.data.items.discountType : '';",this.itemDiscountType);
          // console.log("his.itemDiscountType = this.data.items.discountType ? this.data.items.discountType : '';",this.itemDiscountValue);
          this.cdr.detectChanges(); // Ensure UI updates
          this.jobcardId = this.data?.items[0].jobcardId;
          this.cdr.detectChanges();
         this.getQuoteGrandTotal();
          // Now build form controls
         this.quoteFormArray.clear();

// ✅ Choose items based on type
this.editCustomerQuotation.forEach((item, index) => {
  const isPercentage = item.discountType === 'percentage';
  const group = this.fb.group({
    discountValue: [!isPercentage ? item.discountValue : null],
    discountPercentage: [isPercentage ? item.discountValue : null]
  });

  group.valueChanges.subscribe(discount => {
    this.recalculateMrpWithDiscount(index, discount);
  });

  this.quoteFormArray.push(group);
});

          },
          error => {
            console.error('Error fetching quote details:', error);
          }
        );
      }
  sidebarToggleItemSelectionQuote(){
    this.toggleItemSelectionQuote();

  }
  isAllItemsAndLabourCompleted(): boolean {
    const allItemsCompleted = this.customerQuotation1.every(quote => quote.quoteItemStatus === 1);
    const allLaboursCompleted = this.selectedItemsLabour.every(labour => labour.quoteItemStatus === 1);
    return allItemsCompleted && allLaboursCompleted;
  }
  
  closeAll() {
    this.isEditLabourSidebarOpen = false;
    this.isSidebarOpen = false;
    this.isAddLabour = false;
    this.showSkipConfirmation = false;
    this.ngOnInit();
  }
  
  // Select All for Approving Items
  sidebarToggleSelectAllQuote() {
    this.selectAllQuote = !this.selectAllQuote;
    if (Array.isArray(this.customerQuotation)) {
      this.customerQuotation.forEach(quote => {
        quote.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all parts');   
     }
    if (Array.isArray(this.customerQuotation1)) {
      this.customerQuotation1.forEach(quote => {
        quote.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all parts');   
     }

    if (Array.isArray(this.selectedItemsLabourQuote)) { 
      
      this.selectedItemsLabourQuote.forEach(labour => {
        labour.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all labour');
    }

    
    if (Array.isArray(this.selectedItemsLabour)) {
      this.selectedItemsLabour.forEach(labour => {
        labour.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all labour');
    }
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
  sidebarEditToggleSelectAllQuote() {
    this.selectAllQuote = !this.selectAllQuote;
    if (Array.isArray(this.editCustomerQuotation)) {
      this.editCustomerQuotation.forEach(quote => {
        quote.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all parts');   
     }

    if (Array.isArray(this.editLabourItemsLabourQuote)) {
      this.editLabourItemsLabourQuote.forEach(labour => {
        labour.selected = this.selectAllQuote;
      });
    } else {
      // console.log('error select all labour');
    }
    this.updateSelectedEditItemsQuote();
    this.updateEditSelectedLabourItems(); 
  }

  // toggleEditItemSelectionQuote(): void {
  //   if (Array.isArray(this.editCustomerQuotation)) {
  //     this.selectAllQuote = this.editCustomerQuotation.every(quote => quote.selected);
  //   } else {
  //     this.selectAllQuote = false;
  //   }
  //   if (Array.isArray(this.editLabourItemsLabourQuote)) {
  //     this.editLabourItemsLabourQuote.forEach(labour => {
  //       labour.selected = labour.selected ? true : false;
        
  //     });

  
  //     this.selectedLabourCount = this.editLabourItemsLabourQuote.filter(labour => labour.selected).length;

  //   }
  //    else {
  //     this.selectedLabourCount = 0;
  //   }

    
  //   this.updateSelectedEditItemsQuote();
  //   this.updateEditSelectedLabourItems(); 
  
  //   // Force UI update
  //   this.cdr.detectChanges();
  // }
  toggleEditItemSelectionQuote(): void {
    const allQuotesSelected = Array.isArray(this.editCustomerQuotation) &&
      this.editCustomerQuotation.length > 0 &&
      this.editCustomerQuotation.every(quote => quote.selected);
  
    const allLaboursSelected = Array.isArray(this.editLabourItemsLabourQuote) &&
      this.editLabourItemsLabourQuote.length > 0 &&
      this.editLabourItemsLabourQuote.every(labour => labour.selected);
  
    // ✅ Updated logic to account for empty lists
    this.selectAllQuote = (
      (allQuotesSelected || this.editCustomerQuotation.length === 0) &&
      (allLaboursSelected || this.editLabourItemsLabourQuote.length === 0)
    );
  
    if (Array.isArray(this.editLabourItemsLabourQuote)) {
      this.editLabourItemsLabourQuote.forEach(labour => {
        labour.selected = !!labour.selected;
      });
      this.selectedLabourCount = this.editLabourItemsLabourQuote.filter(labour => labour.selected).length;
    } else {
      this.selectedLabourCount = 0;
    }
  
    this.updateSelectedEditItemsQuote();
    this.updateEditSelectedLabourItems();
    this.cdr.detectChanges();
  }
  
  
  


  addLabourSidebar(){
    this.isAddLabour = !this.isAddLabour; 
    this.labourList();
    
  }
  addEditLabourSidebar(){
    this.isAddLabour = !this.isAddLabour; 
    this.labourEditList();
    
  }

  
  labourRedirectSidebar()
  {
    this.isAddLabour=false;
    this.selectedLabourCount=0;
    }
  
  // labourList() {
  //     const garageKey = localStorage.getItem('garageKey');
  //     console.log("garagekey", garageKey);
  
  //     if (garageKey) {
  //         this.aspRequestDetailsService.displayLabourList(garageKey).subscribe(
  //             (result) => {
  //                 const res = JSON.parse(JSON.stringify(result));
  //                 if (res.code === 200) {
  //                     console.log("labourres", res);
  
  //                     if (!Array.isArray(this.selectedItemsLabourQuote)) {
  //                         this.selectedItemsLabourQuote = [];
  //                     }
  
  //                     this.fullLabourList = res.data.map((labour: any) => ({
  //                         ...labour,
  //                         selected: this.selectedItemsLabourQuote.some(
  //                             (selectedItem: any) =>
  //                                 // selectedItem.labourId === labour.labourId &&
  //                                 selectedItem.labourName === labour.labourName 
  //                                 // selectedItem.labourAmount === labour.labourAmount
  //                         ),
  //                     }));
  
  //                     this.labourListData = [...this.fullLabourList]; // Copy full list to labourListData
  //                     console.log("Updated labourListData:", this.labourListData);
  
  //                     this.updateSelectedLabourItems();
  //                     this.updateSelectedItemsQuote();
  //                 }
  //             },
  //             (error) => {
  //                 console.error('Error fetching labour list:', error);
  //             }
  //         );
  //     } else {
  //         console.warn('Garage key not found in localStorage.');
  //     }
  // }
  
  // updateSelectedLabourItems(): void {
  //   // this.originalLabourQuotes = [...this.selectedItemsLabourQuote];

  //   this.selectedLabours = this.selectedItemsLabourQuote.filter(labour => labour.selected);
  //   this.selectedLabourslength = this.selectedLabours.length;
  
  //   // Do not overwrite the entire array, just calculate selected count and price
  //   this.totallabourSelectedPrice = this.selectedLabours.reduce((sum, labour) => {
  //     return sum + (labour.labourAmount || 0);
  //   }, 0);
  
  //   this.totalSelectedApprovedriceQuote = (this.totallabourSelectedPrice || 0) + (this.totalapproveSelectedPriceQuote || 0);
  //   this.customerQuotationPrice = this.totalSelectedApprovedriceQuote;
  
  //   this.selectedLaboursCount = this.selectedLabours.length || 0;
  //   this.selectedItemsCount = this.selectedLabourslength + this.selectedItemsCountQuote;
  //   // if (this.selectedLabours.length === 0) {
  //   //   this.selectedItemsLabourQuote = [...this.originalLabourQuotes];
  //   // }
    
  //   console.log("Total Selected Labour Price:", this.totallabourSelectedPrice);
  // }

//   labourList() {
//     const garageKey = localStorage.getItem('garageKey');
//     console.log("garagekey", garageKey);

//     if (garageKey) {
//         this.aspRequestDetailsService.displayLabourList(garageKey).subscribe(
//             (result) => {
//                 const res = JSON.parse(JSON.stringify(result));
//                 if (res.code === 200) {
//                     console.log("labourres", res);

//                     if (!Array.isArray(this.selectedItemsLabourQuote)) {
//                         this.selectedItemsLabourQuote = [];
//                     }

//                     this.fullLabourList = res.data
//                         .map((labour: any) => ({
//                             ...labour,
//                             selected: this.selectedItemsLabourQuote.some(
//                                 (selectedItem: any) =>
//                                     selectedItem.labourName === labour.labourName
//                             ),
//                         }))
//                         .sort((a, b) => Number(b.selected) - Number(a.selected)); // Sorting selected items first

//                     this.labourListData = [...this.fullLabourList]; // Copy sorted list to labourListData
//                     console.log("Updated labourListData:", this.labourListData);

//                     this.updateSelectedLabourItems();
//                     this.updateSelectedItemsQuote();
//                 }
//             },
//             (error) => {
//                 console.error('Error fetching labour list:', error);
//             }
//         );
//     } else {
//         console.warn('Garage key not found in localStorage.');
//     }
// }

labourList() {
  const garageKey = localStorage.getItem('garageKey');
  // console.log("garagekey", garageKey);
  // console.log("savedItems---======------", this.selectedItemsLabourQuote);

  if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,this.rateCardApplicable,this.carSize).subscribe(
          (result) => {
              const res = JSON.parse(JSON.stringify(result));
              if (res.code === 200) {
                  // console.log("labourres", res);

                  if (!Array.isArray(this.selectedItemsLabourQuote)) {
                      this.selectedItemsLabourQuote = [];
                  }

                  // ✅ Merge selected labours from previous state
                  this.fullLabourList = res.data.map((labour: any) => {
                      const existingItem = this.selectedItemsLabourQuote.find(
                          (selectedItem: any) => selectedItem.labourId === labour.labourId
                      );

                      return {
                          ...labour,
                          selected: !!existingItem, 
                          quantity: existingItem?.quantity ?? 1, 
                      };
                  });

                  // ✅ Sorting: Move selected items to the top
                  this.fullLabourList.sort((a, b) => Number(b.selected) - Number(a.selected));

                  this.labourListData = [...this.fullLabourList]; 
                  // console.log("Updated labourListData:", this.labourListData);

                  this.updateSelectedLabourItems();
                  this.updateSelectedItemsQuote();
              }
          },
          (error) => {
              console.error('Error fetching labour list:', error);
          }
      );
  } else {
      console.warn('Garage key not found in localStorage.');
  }
}

labourEditList() {
  const garageKey = localStorage.getItem('garageKey');
  // console.log("garagekey", garageKey);
  // console.log("savedItems LABOUR---======------", this.editLabourItemsLabourQuote);

  if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,this.rateCardApplicable,this.carSize).subscribe(
          (result) => {
              const res = JSON.parse(JSON.stringify(result));
              if (res.code === 200) {
                  // console.log("labourres", res);

                  if (!Array.isArray(this.editLabourItemsLabourQuote)) {
                      this.editLabourItemsLabourQuote = [];
                  }

                  // ✅ Merge selected labours from previous state
                  this.fullLabourList = res.data.map((labour: any) => {
                      const existingItem = this.editLabourItemsLabourQuote.find(
                          (selectedItem: any) => selectedItem.labourId === labour.labourId
                      );
                      this.labourjobCardStatus = 3;
                      return {
                          ...labour,
                          selected: !!existingItem, 
                          quantity: existingItem?.quantity ?? 1, 
                          jobCardStatus: this.labourjobCardStatus
                      };
                  });
                  // this.labourjobCardStatus = 3
                  // this.fullLabourList.push(jobcardstatus : this.labourjobCardStatus )
                  // console.log("this.job aCard status------------",this.fullLabourList);

                  // ✅ Sorting: Move selected items to the top
                  this.fullLabourList.sort((a, b) => Number(b.selected) - Number(a.selected));
                  // console.log("FULLLABOURLIST----------------",this.fullLabourList);
                  this.labourListData = [...this.fullLabourList]; 
                  // console.log("Updated labourListData:", this.labourListData);

                  this.updateEditSelectedLabourItems();
                  this.updateSelectedEditItemsQuote();
              }
          },
          (error) => {
              console.error('Error fetching labour list:', error);
          }
      );
  } else {
      console.warn('Garage key not found in localStorage.');
  }
}




saveLabourList() {
  const garageKey = localStorage.getItem('garageKey');
  // console.log("garagekey", garageKey);
  // console.log("savedItems---======------", this.selectedItemsLabourQuote);

  if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,this.rateCardApplicable,this.carSize).subscribe(
          (result) => {
              const res = JSON.parse(JSON.stringify(result));
              if (res.code === 200) {
                  // console.log("labourres", res);

                  if (!Array.isArray(this.selectedItemsLabourQuote)) {
                      this.selectedItemsLabourQuote = [];
                  }

                  this.fullLabourList = res.data
                      .map((labour: any) => ({
                          ...labour,
                          selected: this.selectedItemsLabourQuote.some(
                              (selectedItem: any) =>
                                  selectedItem.labourId === labour.labourId
                          ),
                      }))
                      .sort((a, b) => Number(b.selected) - Number(a.selected)); // Sort selected items first

                  this.labourListData = [...this.fullLabourList]; // Copy full list to labourListData
                  // console.log("Updated labourListData:", this.labourListData);

                  this.updateSelectedLabourItems();
                  this.updateSelectedItemsQuote();
              }
          },
          (error) => {
              console.error('Error fetching labour list:', error);
          }
      );
  } else {
      console.warn('Garage key not found in localStorage.');
  }
}

updateSelectedEditItemsQuote(): void {
// -------------------------EDIT PRICE ----------------------------------------------
const editSelected = this.editCustomerQuotation;
// console.log("editSelected--", editSelected);
this.editSelectedItemsQuote = this.editCustomerQuotation.filter(quote => quote.selected);
// console.log("this.editSelectedItemsQuote---",this.editSelectedItemsQuote);
this.editSelectedQuoteLength = this.editSelectedItemsQuote.length;
// console.log("edit quote length--",this.editSelectedQuoteLength); 
this.totalEditSelectedPriceQuote = this.editCustomerQuotation
  .filter(quote => quote.selected)
  .reduce((total, quote) => total + (quote.mrp * quote.quantity), 0);
  // console.log("saikiran item price",this.totalEditSelectedPriceQuote);
}


updateSelectedItemsQuote(): void {
  this.selectedItemsQuote = this.customerQuotation.filter(quote => quote.selected)
  this.selectedItemsCountQuote = this.customerQuotation.filter(quote => quote.selected).length;
  this.selectedItemsapprovedQuote = this.customerQuotation1.filter(quote => quote.selected);
  this.totalapproveSelectedPriceQuote = (this.customerQuotation.filter(quote => quote.selected).reduce((total, quote) => total+(quote.sellingPrice *quote.quantity), 0))
  this.selectedItemsCountapprovedQuote = (this.customerQuotation1.filter(quote => quote.selected).length | 0)+(this.selectedItemsLabourQuote.filter(quote => quote.selected).length | 0);
  this.selectedAlreadyApprovedQuoteLabourlength=this.selectedItemsLabour.filter(quote => quote.selected).length | 0
  this.selectedAlreadyApprovedQuotelength=(this.customerQuotation1.filter(quote => quote.selected).length | 0)+(this.selectedItemsLabour.filter(quote => quote.selected).length | 0);
  this.selectedAlreadyApprovedQuote=(this.customerQuotation1.filter(quote => quote.selected).reduce((total, quote) => total+(quote.sellingPrice *quote.quantity), 0))+(this.selectedItemsLabour.filter(quote => quote.selected).reduce((total, quote) => total+(quote.labourAmount *quote.quantity),0))
  // this.totalSelectedPrice = this.totalSelectedPrice + ((bidItem.mrp - (bidItem.mrp* bidItem.sellingDiscount /100))*bidItem.itemQuantity);
  this.totalSelectedPriceQuote = this.customerQuotation.filter(quote => quote.selected).reduce((total, quote) => total+(quote.mrp *quote.quantity), 0);
}
updateEditSelectedLabourItems() : void {
  // ---------------------Edit price -----------------------------
  // console.log("this.eidtLabourItemsLabour Quote---",this.editLabourItemsLabourQuote);
  this.editLabourItemsLabourQuote1 = this.editLabourItemsLabourQuote.filter(labour => labour.selected);
  this.editlabourlength = this.editLabourItemsLabourQuote1.length;
  // console.log("labour length---",this.editlabourlength);
 
  this.totallabourSelectedPrice = this.editLabourItemsLabourQuote1.reduce((sum, labour) => {
    return sum + (Number(labour.labourAmount) * Number(labour.quantity || 1) || 0);
  }, 0);

  this.totalEditQuoteItemsCount = (this.editSelectedQuoteLength || 0) + (this.editlabourlength || 0);
  this.totalSelectedEditPriceQuote = (this.totalEditSelectedPriceQuote || 0) + (this.totallabourSelectedPrice || 0);
// --------------------------------Discount--------------------------------
// console.log("this.discountType",this.discountType);
// console.log("this.discountValue",this.discountValue);
// discouunt type and discount values
if (this.discountType === 'rupees') {
  this.calculatedDiscount = this.discountValue;
} else if (this.discountType === 'percentage') {
  this.calculatedDiscount = (this.totalSelectedEditPriceQuote * this.discountValue) / 100;
}
// console.log("this.calculatedDiscount---",this.calculatedDiscount);
// ------------------------------------------------------------------------

  // console.log("--------------------Edit Details----------------")
  // console.log("Items count--",this.editSelectedQuoteLength)
  // console.log("labour count ---",this.editlabourlength)
  // console.log("items price------",this.totalEditSelectedPriceQuote)
  // console.log("labour price----",this.totallabourSelectedPrice )
  // console.log("-----------------------------------------------------")
  this.totalEditQuoteItemsCount = (this.editSelectedQuoteLength || 0) + (this.editlabourlength || 0);
  // console.log("this.totalEditQuoteItemsCount--",this.totalEditQuoteItemsCount);
}

updateSelectedLabourItems(): void {
  this.selectedLabours = Array.isArray(this.selectedItemsLabourQuote)
    ? this.selectedItemsLabourQuote.filter(labour => labour.selected)
    : [];
  this.selectedLabourslength = this.selectedLabours.length;
  this.totallabourSelectedPrice = this.selectedLabours.reduce((sum, labour) => {
    return sum + (Number(labour.labourAmount) * Number(labour.quantity || 1) || 0);
  }, 0);
  // -------------------------------------------------------
  this.totalSelectedApprovedriceQuote = (this.totallabourSelectedPrice || 0) + (this.totalapproveSelectedPriceQuote || 0);
  // this.customerQuotationPrice = this.totalSelectedApprovedriceQuote;
// console.log("totalSelectedApprovedPrieQuote---",this.totalSelectedApprovedriceQuote);
  this.selectedLaboursCount = this.selectedLabours.length || 0;
  this.selectedItemsCount = this.selectedLabourslength + (this.selectedItemsCountQuote || 0);
  this.totalSelectedPriceQuote1 = Number(this.totallabourSelectedNewPrice);

  // ------------------------Discount------------------------
  if (this.totalSelectedApprovedriceQuote){
    if (this.discountType === 'rupees') {
      this.calculatedDiscount = this.discountValue;
    } else if (this.discountType === 'percentage') {
      this.calculatedDiscount = (this.totalSelectedApprovedriceQuote * this.discountValue) / 100;
    }
  } else {
    if (this.discountType === 'rupees') {
      this.calculatedDiscount = this.discountValue;
    } else if (this.discountType === 'percentage') {
      this.calculatedDiscount = (this.selectedAlreadyApprovedQuote * this.discountValue) / 100;
    }
  }
  this.cdr.detectChanges();
}

  anyItemEditSelected() {
    return this.totalEditQuoteItemsCount > 0
  }
  
   anyItemSelectedQuote() {
    return this.selectedItemsCount > 0;
  }
  
  

  incrementjobcardQuantity(quote:any):void {
    quote.itemQuantity++;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.getQuoteGrandTotal();
  }
  incrementQuantity(quote: any): void {
    quote.quantity++;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.updateSelectedEditItemsQuote();
    this.updateEditSelectedLabourItems();
    this.getQuoteGrandTotal();
    
  
  }
  decrementQuantity(quote: any): void {
    if (quote.quantity > 1) { 
      quote.quantity--;
      this.customerQuotationPrice = this.calculateTotalQuotationPrice();
      this.updateSelectedEditItemsQuote();
      this.updateEditSelectedLabourItems();
      this.getQuoteGrandTotal();
    }
  }
  decrementjobcardQuantity(quote:any): void{
    if (quote.itemQuantity > 1) { 
      quote.itemQuantity--;
      this.customerQuotationPrice = this.calculateTotalQuotationPrice();
      this.updateSelectedItemsQuote();
      this.updateSelectedLabourItems();
      this.getQuoteGrandTotal();
    }
  }
  incrementLabourQuantity(quote: any): void {
    if (quote.quantity >= 1) {
      quote.quantity++;
    }
  
    // ✅ Recalculate labour price and update UI
    this.labourQuotationPrice = this.calculateTotalLabourPrice();
    this.updateSelectedEditItemsQuote();
    this.updateEditSelectedLabourItems();
    this.getQuoteGrandTotal();
    this.cdr.detectChanges();
  }
  
  decrementLabourQuantity(quote: any): void {
    if (quote.quantity > 1) { // ✅ Prevents quantity from going below 1
      quote.quantity--;
    }
  
    // ✅ Recalculate labour price and update UI
    this.labourQuotationPrice = this.calculateTotalLabourPrice();
    
    this.updateSelectedEditItemsQuote();
    this.updateEditSelectedLabourItems();
    this.getQuoteGrandTotal();
    this.cdr.detectChanges();
  }
  

  calculateTotalLabourPrice(): number {
    return this.selectedItemsLabourQuote.reduce(
      (sum, item) => sum + (Number(item.labourAmount) * Number(item.quantity || 1)), 0
    );
  }
  openSkipConfirmation(){
    this.showSkipConfirmation = true;
  }
  closeSkipConfirmation(): void {
    this.showSkipConfirmation = false;
  }
  confirmSkip(): void {
    this.showSkipConfirmation = false;
    this.isAddLabour = false;
    // console.log('Skip confirmed!');
  }
  // fullLabourList
  toggleSelectItem(): void {
    // console.log("selectedItemsLabourQuote---",this.selectedItemsLabourQuote)
    this.selectedItemsLabourQuote = this.labourListData.filter(item => item.selected);
    this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
      (sum, item) => sum + (item.labourAmount || 0),0);
    // console.log('Selected Items:', this.selectedItemsLabourQuote);
    // console.log('Total Selected Price:', this.totalSelectedPriceQuote1);
    this.isAddLabour = false;
    this.getQuoteGrandTotal();
  }

  toggleEditSelectItem(): void {
    // ✅ Pull from the full list to retain all selections
    this.selectedItemsLabourQuote = this.fullLabourList.filter(item => item.selected);
  
    // ✅ Copy selected items with correct quantities
    this.editLabourItemsLabourQuote = this.selectedItemsLabourQuote.map(labour => ({
      ...labour,
      quantity: labour.quantity || 1
    }));
  
    this.totalSelectedPriceQuote1 = this.editLabourItemsLabourQuote.reduce(
      (sum, item) => sum + (Number(item.labourAmount) * (item.quantity || 1)), 
      0
    );
  
    this.isAddLabour = false;
    this.clearLabourSearch();
    this.getQuoteGrandTotal();
  }
  
  // onLabourSelectionChange(labour: any): void {
  //   if (!labour) {
  //     console.error('Labour object is undefined');
  //     return;
  //   }

  //   labour.selected = labour.selected || false;

  //   this.selectedItemsLabourQuote = this.labourListData.filter(l => l.selected);
  //    this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected).length;
  //   // Update counts and prices

  //   this.updateSelectedLabourItems();
  //   this.updateSelectedItemsQuote();
  // }
  onLabourSelectionChange(labour: any): void {
    // console.log("this.labourListData before change:", this.labourListData);
    // console.log("this.selectedItemsLabourQuote before change:", this.selectedItemsLabourQuote);
  
    if (!labour) {
      console.error('Labour object is undefined');
      return;
    }
    labour.selected = labour.selected || false;
    let existingLabour = this.selectedItemsLabourQuote.find(l => l.id === labour.id);
  
    if (existingLabour) {
      labour.quantity = existingLabour.quantity;
    } else {
      labour.quantity = 1;
    }
    this.selectedItemsLabourQuote = this.labourListData
      .filter(l => l.selected)
      .map(l => {
        let existingItem = this.selectedItemsLabourQuote.find(item => item.id === l.id);
        return existingItem ? { ...existingItem } : { ...l, quantity: 1 }; 
      });
  
    // ✅ Calculate total selected price including quantity
    this.totallabourListSelectedPrice = this.selectedItemsLabourQuote.reduce(
      (sum, labour) => sum + (Number(labour.labourAmount) * (labour.quantity || 1)), 
      0
    );
  
    // console.log("Updated selectedItemsLabourQuote:", this.selectedItemsLabourQuote);
    // console.log("Updated selectedLabourPrice:", this.totallabourListSelectedPrice);
  
    // ✅ Update selected labour count
    this.selectedLabourCount = this.selectedItemsLabourQuote.length;
  
    // ✅ Calculate total price
    this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
      (sum, item) => sum + (Number(item.labourAmount) * (item.quantity || 1)), 
      0
    );
  
    // Update UI
    this.updateSelectedLabourItems();
    this.updateSelectedItemsQuote();
  }

  onLabourEditSelectionChange(labour: any): void {  
    if (!labour) {
      console.error('Labour object is undefined');
      return;
    }
    labour.selected = labour.selected || false;
    let existingLabour = this.editLabourItemsLabourQuote.find(l => l.id === labour.id);
    // console.log("existingLabour---",existingLabour);
    if (existingLabour) {
      labour.quantity = existingLabour.quantity;
    } else {
      // If new, set default quantity to 1
      labour.quantity = 1;
    }
  
    // ✅ Merge existing selected items with the newly selected ones
    this.editLabourItemsLabourQuote = this.labourListData
      .filter(l => l.selected)
      .map(l => {
        let existingItem = this.editLabourItemsLabourQuote.find(item => item.id === l.id);
        return existingItem ? { ...existingItem } : { ...l, quantity: 1 }; // Keep existing quantity or set default
      });
    this.totallabourListSelectedPrice = this.editLabourItemsLabourQuote.reduce(
      (sum, labour) => sum + (Number(labour.labourAmount) * (labour.quantity || 1)), 
      0
    );
    this.selectedLabourCount = this.editLabourItemsLabourQuote.length;
    this.totalSelectedPriceQuote1 = this.editLabourItemsLabourQuote.reduce(
      (sum, item) => sum + (Number(item.labourAmount) * (item.quantity || 1)), 
      0
    );
    this.updateEditSelectedLabourItems();
    this.updateSelectedEditItemsQuote();
  }
  
  openLabourEditSidebar(item: any = null) {
    this.isEditLabourSidebarOpen = true;
    // this.isAddLabour = item ? false : true;
    this.isSidebarOpen = false;
  // console.log("sdjfjsdfjisdf")
    if (item) {
      this.selectedLabour = { ...item };
      this.labourName = this.selectedLabour.labourName;
      this.labourAmount = this.selectedLabour.labourAmount;
      this.labourId = this.selectedLabour.labourId;
      this.id = this.selectedLabour.id;
      // console.log("Editing Labour:", this.selectedLabour);
    } else {
      this.selectedLabour = { name: '', price: null };
      // console.log("Adding New Labour:", this.selectedLabour);
    }
  }
  
  // onLabourSearch(): void {
    // console.log('Search Triggered:', this.searchText);
  //   const query = this.searchText?.toLowerCase();
  //   if (query) {
  //     this.labourListData = this.labourListData.filter(item =>
  //       item.labourName?.toLowerCase().includes(query)
  //     );
  //   // if(this.searchText=''){
  //   //   this.labourList();
  //   // }
  //   } else {
  //     console.log('Resetting filteredItems1 to full list.');
  //     this.filteredItems1 = [...this.labourListData]; // Reset to full list
  //   }
  //   console.log('Filtered Items:', this.filteredItems1);
  // }

  onLabourSearch(): void {
    // console.log('Search Triggered:', this.searchText);
    const query = this.searchText?.toLowerCase();

    if (query) {
        this.labourListData = this.fullLabourList.filter(item =>
            item.labourName?.toLowerCase().includes(query)
        );
    } else {
        // Reset to full list when search is cleared
        this.labourListData = [...this.fullLabourList];
    }

    // console.log('Filtered Items:', this.labourListData);
}

  
  // clearLabourSearch(){
  //   this.searchText='';
  //   this.labourList();
  // }

  clearLabourSearch() { 
    this.searchText = '';
    this.labourListData = [...this.fullLabourList]; // Restore full list
}


// approveQuote(){
//   let customerQuoteItems: any = [];
//   let labourQuoteItems: any = [];
//   let jobcardId:number = 0;
//   // console.log("quotationrecieved----",this.selectedItemsQuote);
//   // console.log("abours---",this.selectedLabours);
//   this.selectedItemsQuote.forEach(received => {
    
//     if (received.selected === true) {
//       let data = {};
//       data['id'] = received.itemId;
//       data['jobCardStatus'] = 4;
//       data['jobcardId'] = received.jobcardId;
//       this.jobcardId=received.jobcardId
//       customerQuoteItems.push(data);
//     }
// });
// this.selectedLabours.forEach(labour => {
//   if (labour.selected === true) {
//     let data = {
//       labourId: labour.labourId,  
//       jobCardStatus: 4,
//       jobcardId: labour.jobcardId
//     };
//     this.jobcardId = labour.jobcardId;
//     labourQuoteItems.push(data);
//   }
// });

// let param = {
//   "jobcardId":this.jobcardId,
//   "customerQuoteItems": customerQuoteItems,
//   "labourQuoteItems" : labourQuoteItems ,
//   "customerQuoteId": this.quoteId ,
//   "discountType": this.discountType || null,
//   "discountValue": this.discountValue || 0.0,
  
// }
// this.aspQuotationDetailsService.approveQuotation(param).subscribe(
//   result => {
   
//     const res = JSON.parse(JSON.stringify(result));
//     this.sidebarOpenQuote = false;
//     this.isApprovePopUpOpen = true;
//     this.grandApprovedTotal();
    
//     (document.getElementsByClassName('approval-due')[0] as HTMLInputElement).innerHTML = "In Progress";
//     (document.getElementsByClassName('approval-due')[0] as HTMLInputElement).style.backgroundColor = "orange";

//   },
//   error => {
//     this.toastr.error('Error approving quotation:', error);
//   }
// );

// }


approveQuote() {
  let customerQuoteItems: any = [];
  let labourQuoteItems: any = [];
  let jobcardId: number = 0;

  const discountFormArray = this.mainForm.get('quoteFormArray')?.value || [];
  // console.log("this.selectedItemQuote-----",this.selectedItemsQuote);
  this.selectedItemsQuote.forEach((received, index) => {
    if (received.selected === true) {
      let discountType = '';
      let discountValue = 0;

      const discountEntry = discountFormArray[index] || {};
      if (discountEntry.discountValue && discountEntry.discountValue > 0) {
        discountType = 'rupees';
        discountValue = discountEntry.discountValue;
      } else if (discountEntry.discountPercentage && discountEntry.discountPercentage > 0) {
        discountType = 'percentage';
        discountValue = discountEntry.discountPercentage;
      }

      let data: any = {
        id: received.itemId,
        jobCardStatus: 4,
        jobcardId: received.jobcardId,
        discountType: discountType,
        discountValue: discountValue
      };

      jobcardId = received.jobcardId;
      customerQuoteItems.push(data);
    }
  });

  this.selectedLabours.forEach(labour => {
    if (labour.selected === true) {
      let data = {
        labourId: labour.labourId,
        jobCardStatus: 4,
        jobcardId: labour.jobcardId
      };
      jobcardId = labour.jobcardId;
      labourQuoteItems.push(data);
    }
  });

  let param = {
    jobcardId: jobcardId,
    customerQuoteItems: customerQuoteItems,
    labourQuoteItems: labourQuoteItems,
    customerQuoteId: this.quoteId
  };

  this.aspQuotationDetailsService.approveQuotation(param).subscribe(
    result => {
      const res = JSON.parse(JSON.stringify(result));
      this.sidebarOpenQuote = false;
      this.isApprovePopUpOpen = true;
      this.grandApprovedTotal();

      const approvalDue = document.getElementsByClassName('approval-due')[0] as HTMLElement;
      approvalDue.innerHTML = "In Progress";
      approvalDue.style.backgroundColor = "orange";
    },
    error => {
      this.toastr.error('Error approving quotation:', error);
    }
  );
}

  get up() {
    return this.unitPrice.controls;
  }
    
    get ld() {
      return this.laborDetails.controls;
    }
  
  
  closeLabourEditSidebar() {
    this.isEditLabourSidebarOpen = false;
      this.selectedLabour = { labourName: '', labourAmount: null };
    // this.isAddLabour=false;
    
  
  }
//   saveLabour(): void {
//     console.log("Labour Name:", this.ld.labourName.value);
//     console.log("Labour Amount:", this.ld.labourAmount.value);
//     console.log("Selected Labour:", this.selectedLabour);

//     this.selectedItemsLabourQuote.forEach(labour => {
//       if(labour.labourId==this.selectedLabour.labourId){
//         labour.labourName = this.ld.labourName.value;
//         labour.labourAmount = this.ld.labourAmount.value;
//       }
//     });
//     console.log("selectedItemsLabourQuote:", this.selectedItemsLabourQuote);

//     const updatedLabourName = this.ld.labourName.value;
//     const updatedLabourAmount = this.ld.labourAmount.value;
//     const garageKey = localStorage.getItem('garageKey');

//     this.aspRequestDetailsService
//       .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount)
//       .subscribe(
//         (result) => {
//           console.log('API Response:', result);
//           const res = JSON.parse(JSON.stringify(result));
//           if (res.code === 200) {
//             console.log('Labour edited successfully:', res);
//             this.toastr.success("Labour saved Successfully");
//             this.labourList(); 
//             const index = this.selectedItemsLabourQuote.findIndex(item => item.id === this.id);
//             if (index !== -1) {
//               this.selectedItemsLabourQuote[index].labourName = updatedLabourName;
//               this.selectedItemsLabourQuote[index].labourAmount = updatedLabourAmount;
//             }

//             console.log("Updated selectedItemsLabourQuote:", this.selectedItemsLabourQuote);
//           } else {
//             console.warn('Unexpected response code:', res.code);
//           }
//         },
//         (error) => {
//           console.error('Error editing labour:', error);
//         }
//       );
//       this.getQuoteGrandTotal();
//     this.closeLabourEditSidebar();
// }

saveLabour(): void {
  console.log("Labour Name:", this.ld.labourName.value);
  console.log("Labour Amount:", this.ld.labourAmount.value);

  const updatedLabourName = this.ld.labourName.value;
  const updatedLabourAmount = this.ld.labourAmount.value;
  const garageKey = localStorage.getItem('garageKey');
  const status = this.status ?? 1;

  console.log("before labourId-----", this.labourId);
  this.aspRequestDetailsService
      .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize,status)
      .subscribe(
          (result) => {
              // console.log('API Response:', result);
              const res = JSON.parse(JSON.stringify(result));

              if (res.code === 200) {
                  // console.log('Labour edited successfully:', res);
                  this.toastr.success("Labour saved Successfully");
                  // console.log("this.labourId", this.labourId);

                  let labourExists = false;
                  this.selectedItemsLabourQuote = this.selectedItemsLabourQuote.map(item => {
                      if (item.labourId === this.labourId) {
                          labourExists = true;
                          return {
                              ...item,
                              labourName: updatedLabourName,
                              labourAmount: updatedLabourAmount,
                              selected: true
                          };
                      }
                      return item;
                  });

                  // ✅ Ensure the edited labour is still selected
                  if (!labourExists) {
                      this.selectedItemsLabourQuote.push({
                          id: this.id,
                          labourId: this.labourId,
                          labourName: updatedLabourName,
                          labourAmount: updatedLabourAmount,
                          selected: true
                      });
                  }
                  // console.log("Updated selectedItemsLabourQuote:", this.selectedItemsLabourQuote);
                  this.labourList();
                  this.getQuoteGrandTotal();  
              } else {
                  console.warn('Unexpected response code:', res.code);
              }
          },
          (error) => {
              console.error('Error editing labour:', error);
          }
      );

  this.closeLabourEditSidebar();
}

saveEditLabour(): void {
  // console.log("Labour Name:", this.ld.labourName.value);
  // console.log("Labour Amount:", this.ld.labourAmount.value);

  const updatedLabourName = this.ld.labourName.value;
  const updatedLabourAmount = this.ld.labourAmount.value;
  const garageKey = localStorage.getItem('garageKey');
  const status = this.status ?? 1;

  // console.log("before labourId-----", this.labourId);
  this.aspRequestDetailsService
      .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize,status)
      .subscribe(
          (result) => {
              // console.log('API Response:', result);
              const res = JSON.parse(JSON.stringify(result));

              if (res.code === 200) {
                  // console.log('Labour edited successfully:', res);
                  this.toastr.success("Labour saved Successfully");
                  // console.log("this.labourId", this.labourId);

                  let labourExists = false;
                  this.editLabourItemsLabourQuote = this.editLabourItemsLabourQuote.map(item => {
                      if (item.labourId === this.labourId) {
                          labourExists = true;
                          return {
                              ...item,
                              labourName: updatedLabourName,
                              labourAmount: updatedLabourAmount,
                              selected: true
                          };
                      }
                      return item;
                  });

                  // ✅ Ensure the edited labour is still selected
                  if (!labourExists) {
                      this.editLabourItemsLabourQuote.push({
                          id: this.id,
                          labourId: this.labourId,
                          labourName: updatedLabourName,
                          labourAmount: updatedLabourAmount,

                          selected: true
                      });
                  }
                  // console.log("Updated editLabourItemsLabourQuote:", this.editLabourItemsLabourQuote);
                  this.labourEditList();
                  this.getQuoteGrandTotal();  
              } else {
                  console.warn('Unexpected response code:', res.code);
              }
          },
          (error) => {
              console.error('Error editing labour:', error);
          }
      );

  this.closeLabourEditSidebar();
}



loadOrderDetails(){
   
this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  this.router.navigate(['my-job-cards-details/'+this.jobcardId+'/'+this.bookingId]);
});}

  openPopUp(){
    this.showCancelConfirmation = true;
    this.isAddLabour = false;
  }

  addLabour() {
    // console.log(this.ld.labourAmount.value);
    const updatedLabourName = this.ld.labourName.value;
    const updatedLabourAmount = this.ld.labourAmount.value;
    const garageKey = localStorage.getItem('garageKey');
  
    this.aspRequestDetailsService.addLabourList(garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize)
      .subscribe((result) => {
        const res = JSON.parse(JSON.stringify(result));
  
        if (res.code === 200) {
          // console.log("addLabour--", res);
          
          const newLabour = {
            labourId: res.data?.labourId,
            labourName: updatedLabourName,
            labourAmount: updatedLabourAmount,
            selected: true, 
            quantity: 1,
            id: res.data?.id
          };
  
          // ✅ Always add it to selectedItemsLabourQuote
          this.selectedItemsLabourQuote.push(newLabour);
  
          // ✅ Add to labourListData
          this.labourListData.unshift(newLabour);
          
          // console.log("this.labourcount----", this.labourCount);
          // this.updateSelectedLabourItems();
          this.closeLabourEditSidebar();
          this.toastr.success("Labour Added Successfully");
  
          // ✅ Instead of reloading everything, just update UI
          this.labourEditList();
        } else {
          this.toastr.error("Labour Name Already Exists");
        }
      });
  }

  addEditLabour() 
  {
      //  console.log(this.ld.labourAmount.value);
    const updatedLabourName = this.ld.labourName.value;
    const updatedLabourAmount = this.ld.labourAmount.value;
    const garageKey = localStorage.getItem('garageKey');
  
    this.aspRequestDetailsService.addLabourList(garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize)
      .subscribe((result) => {
        const res = JSON.parse(JSON.stringify(result));
  
        if (res.code === 200) {
          // console.log("addLabour--", res);
          
          const newLabour = {
            labourId: res.data?.labourId,
            labourName: updatedLabourName,
            labourAmount: updatedLabourAmount,
            selected: true, 
            quantity: 1,
            jobCardStatus :3,
            id: res.data?.id
          };
          this.editLabourItemsLabourQuote.push(newLabour);
          this.labourListData.unshift(newLabour);
          
          // console.log("this.labourcount----", this.labourCount);
          // this.updateSelectedLabourItems();
          this.closeLabourEditSidebar();
          this.toastr.success("Labour Added Successfully");
  
          // ✅ Instead of reloading everything, just update UI
          this.labourEditList();
          
        } else {
          this.toastr.error("Labour Name Already Exists");
        }
      });

  }
  
  

  closeCancelPopup(): void {
    this.showCancelConfirmation = false;
  }
  openPopup(): void {
    this.showSkipConfirmation = false;
    this.isAddLabour = false;
    this.CloseSidebarQuote();
    this.submitData(); 
  }
  closePopup(): void {
    this.isPopupOpen = false;
  }
  
  calculateTotalAmount(): number {
    return this.data?.items?.reduce((total, item) => {
      return total + (item.sellingPrice * item.quantity);
    }, 0) || 0; // Ensure a fallback value if items is undefined
  }

  calculateLabourAmount(): number {
    return this.data?.labourQuoteItemResponses?.reduce((total, item) => {
      return total + (item.labourAmount * item.quantity);
    }, 0) || 0; 
  }

  calculateTotalQuoteAmount(): number {
    const totalAmount = this.calculateTotalAmount();
    const labourAmount = this.calculateLabourAmount();
    return totalAmount + labourAmount;
  }
  
  // calculateDiscountAmount(): number {
  //   return this.data.discountValue
  //   //  = this.calculateDiscountAmount();

  // }
  calculateDiscountAmount(): number {
    const totalAmount = this.calculateTotalQuoteAmount();
  
    let discountValue = this.data?.discountValue ? this.data.discountValue : 0
    if (this.discountType === 'rupees') {
      return discountValue;
    } else {
      return (discountValue / 100) * totalAmount;
    }
  }
  
  // calculateDiscountPercentage(): number {
  //   const totalAmount = this.calculateTotalQuoteAmount();
  //   const discountAmount = this.calculateDiscountAmount(); 
  
  //   // console.log("Total Amount:", totalAmount);
  //   // console.log("Discount Amount:", discountAmount); 
    
  //   if (totalAmount === 0 || !discountAmount) {
  //     return 0; 
  //   }
  
  //   const discountPercentage = (discountAmount / totalAmount) * 100;
    
  //   // console.log("Calculated Discount Percentage:", discountPercentage); 
  
  //   return discountPercentage; 
  // }

  calculateDiscountPercentage(): number {
    if (this.discountType === 'percentage') {
      return this.data.discountValue;
    }
  
    const totalAmount = this.calculateTotalQuoteAmount();
    const discountAmount = this.calculateDiscountAmount();
  
    if (totalAmount === 0 || !discountAmount) {
      return 0;
    }
  
    return (discountAmount / totalAmount) * 100;
  }
  
  
  
getRequestDetails() {
  const garageKey = localStorage.getItem('garageKey');
  const requestId = this.requestId;
  // console.log("this.requestId",requestId);
  const userKey = localStorage.getItem('spareUserKey');

  this.aspCustomerQuoteService.requestDetails(garageKey, requestId, userKey).subscribe(result => {
    const res = JSON.parse(JSON.stringify(result));
  
    
    if (res.code === 200) {
      this.requestDetails = res.data;
      // console.log("spare-request----",this.requestDetails);

      
      this.requestDetails.spareRequestItemList.forEach(item => {

        res.data.bidDetails.forEach(bid => {
          bid.estimateItem[item.itemName].forEach(bidItem => {
            
            bidItem.itemName = item.itemName;
            // bidItem.itemBrand=item.itemBrand;
            bidItem.itemQuantity = item.itemQuantity;                                
            bidItem.itemStatus = item.status; 
            bidItem.itemId = item.id;
            bidItem.lineitemId = item.lineitemId;
            bidItem.spareQuotationId = item.spareQuotationId;      
            if ([4, 5, 6, 7, 8, 9].includes(bidItem.itemStatus)) {                          
              this.customerQuotation.push(bidItem);            
              this.customerQuotationPrice = this.customerQuotationPrice + (bidItem.mrp *bidItem.itemQuantity);
            }

          });            
        });
        
      });
    }
  });
}


submitData() {
  if (!this.quoteId) {
    // console.log("this.quoteId")
    this.selectedItems = this.customerQuotation.filter(quote => quote.selected)
    this.selectedItems.forEach(item => {
      this.item=item.bidId;
    });

    const cleanData = {
      
      bidId: this.item,
      garageKey: localStorage.getItem('garageKey'),
      items: this.selectedItems.map(item => ({
        id: item.itemId,
        part_name: item.itemName,
        hsnCode:item.hsnCode,
        gstRate:item.gstRate,
        partNumber: item.partNumber,
        sellingPrice: item.sellingPrice, // ✅ Fixed
    mrp: item.originalMrp ?? item.mrp 
      })),
      labourItems:[],
      registrationNumber: this.regiNo,
      requestId: this.requestId,
      userKey:localStorage.getItem('spareUserKey'),
    };
        // 🟢 Get the discount values from the FormArray
    const discountFormArray = this.mainForm.get('quoteFormArray')?.value || [];

    // 🟢 Merge discount into items with proper discountType and discountValue
    const itemsWithDiscount = this.selectedItems.map((item, index) => {
      const discountEntry = discountFormArray[index] || {};
      let discountType = '';
      let discountValue = 0;

      if (discountEntry.discountValue && discountEntry.discountValue > 0) {
        discountType = 'rupees';
        discountValue = discountEntry.discountValue;
      } else if (discountEntry.discountPercentage && discountEntry.discountPercentage > 0) {
        discountType = 'percentage';
        discountValue = discountEntry.discountPercentage;
      }

      return {
        id: item.itemId,
        partName: item.itemName,
        itmQty: item.itemQuantity,
        brand: item.brand,
        partNumber: item.partNumber,
        // sellingPrice: item.mrp,
        // mrp: item.mrp,
         sellingPrice: item.originalMrp ?? item.mrp, // ✅ USE ORIGINAL
    mrp: item.originalMrp ?? item.mrp,
        hsnCode: item.hsnCode,
        gstRate: item.gstRate,
        discountType: discountType,
        discountValue: discountValue
      };
    });

    this.aspCustomerQuoteService.submitData(cleanData).subscribe(response => {
      this.resData=response['data'];
      this.dataid=response['data'].id;
      console.error('response:',response );
    }, error => {
      console.error('Error occurred:', error);
    });
  }else{    
    if (this.quoteId) {
      // console.log(this.quoteId)
      this.submitDataUpdate();
    }
  }
}
get isAllCompleted(): boolean {
  return this.customerQuotation1.every(quote => quote.quoteItemStatus === 1) &&
         this.selectedItemsLabour.every(labour => labour.quoteItemStatus === 1);
}
// submitDataUpdate() {
//   const quotationImages = [];
//   const updatedQuotationImages = [...quotationImages, ...this.quotationImages];
//   console.log("updatedQuotationImages--", updatedQuotationImages);

//   this.aspLoadingService.show();
//   this.selectedItems = this.editCustomerQuotation.filter(
//     quote => quote.selected || quote.jobCardStatus === 3
//   );
//   this.selectedLabours = this.editLabourItemsLabourQuote.filter(labour => labour.selected || labour.jobCardStatus === 3);
//   // this.selectedLabours = this.editLabourItemsLabourQuote.filter(labour => labour.selected);
// console.log("editCustomerQuotation----",this.editCustomerQuotation);
//   console.log("this.selectedLabour----", this.selectedLabours);
//   console.log("this.selectedItems---", this.selectedItems);

//   // Store the bidId from selected spare parts (assuming same for all)
//   if (this.selectedItems.length > 0) {
//     this.item = this.selectedItems[0].bidId;
//   }

//   const itemsData = this.selectedItems.map(item => ({
//     id: item.itemId,
//     itemName: item.itemName,
//     partNumber: item.partNumber,
//     hsnCode: item.hsnCode,
//     gstRate: item.gstRate,
//     sellingPrice: item.mrp,
//     mrp: item.mrp,
//     brand: item.brand,
//     itemQuantity: item.quantity,
  
//     // Add jobCardStatus if it is 2 or 3
//     ...(item.jobCardStatus === 2 || item.jobCardStatus === 3 ? { jobCardStatus: item.jobCardStatus } : {})
//   }));
  

//   const labourItemsData = this.selectedLabours.map(labour => ({
//     labourId: labour.labourId,
//     customerQuoteId: labour.customerQuoteId || 0,
//     labourName: labour.labourName,
//     itmQty: labour.quantity || 1,
//     labourAmount: labour.labourAmount || 0,
  
//     ...(labour.jobCardStatus === 2 || labour.jobCardStatus === 3 ? { jobCardStatus: labour.jobCardStatus } : {})
//   }));
  
//   const cleanData1 = {
//     bidId: this.item,
//     garageKey: localStorage.getItem('garageKey'),
//     bookingId: this.bookingId,
//     items: itemsData,
//     labourItems: labourItemsData,
//     quoteId: this.quoteId,
//     registrationNumber: this.regiNo,
//     jobcardId: this.jobcardId,
//     requestId: this.requestId,
//     userKey: localStorage.getItem('spareUserKey'),
//     quotationImages: updatedQuotationImages,
//     discountType: this.discountType || null,            
//     discountValue: this.discountValue || 0.0,
//   };

//   console.log("cleanData1----",cleanData1);

//   this.aspCustomerQuoteService.submitDataUpdate(cleanData1).subscribe(
//     response => {
//       this.aspLoadingService.hide();
//       if (response['code'] == 200) {
//         this.resData = response['data'];
//         this.isPopupOpen = true;
//         localStorage.removeItem('activeTab');
//         localStorage.removeItem('requestedQuoteItems');
//       } else {
//         this.toastr.error(response['message']);
//       }
//     },
//     error => {
//       this.aspLoadingService.hide();
//       this.toastr.error('Failed to create quotation.');
//     }
//   );
// }


submitDataUpdate() {
  const quotationImages = [];
  const updatedQuotationImages = [...quotationImages, ...this.quotationImages];
  // console.log("updatedQuotationImages--", updatedQuotationImages);

  this.aspLoadingService.show();
//  console.log("jobcardstatus=======================",this.editCustomerQuotation )
  this.selectedItems = this.editCustomerQuotation
  .filter(
    quote => quote.selected || quote.jobCardStatus === 4 
  );
  this.selectedLabours = this.editLabourItemsLabourQuote
  .filter(labour => labour.selected || labour.jobCardStatus === 4  );
  // console.log("editLabourItemsqUOTE OF status 3 in labour----",this.editLabourItemsLabourQuote)
  // .filter(
  //   labour => labour.selected || labour.jobCardStatus === 2 || labour.jobCardStatus === 3
  // );

  // console.log("editCustomerQuotation----", this.editCustomerQuotation);
  // console.log("this.selectedLabour----", this.selectedLabours);
  // console.log("this.selectedItems---", this.selectedItems);

  if (this.selectedItems.length > 0) {
    this.item = this.selectedItems[0].bidId;
  }

 const discountFormArray = this.mainForm?.get('quoteFormArray')?.value || [];
//  console.log("this.selectedItems----",this.selectedItems);

// const itemsData = this.selectedItems.map((item, index) => {
//   const discountEntry = discountFormArray[index] || {};
//   const discountValue = +discountEntry.discountValue || 0;
//   const discountPercentage = +discountEntry.discountPercentage || 0;

//   let discountType: string | null = null;
//   let discountVal: number = 0;

//   if (discountPercentage > 0) {
//     discountType = 'percentage';
//     discountVal = discountPercentage;
//   }

//   return {
//    id: item.itemId,
//       partName: item.itemName,
//       itemQuantity: item.quantity,
//       brand: item.brand,
//       partNumber: item.partNumber,
//       sellingPrice: item.sellingPrice,
//       mrp: item.originalMrp ?? item.mrp,
//       hsnCode: item.hsnCode,
//       gstRate: item.gstRate,
//       discountType: 'percentage',
//       discountValue: +discountPercentage.toFixed(2)
//     };
// });

const itemsData = this.selectedItems.map((item, index) => {
  const discountEntry = discountFormArray[index] || {};
  const discountValue = +discountEntry.discountValue || 0;
  const discountPercentage = +discountEntry.discountPercentage || 0;

  let discountType: string | null = null;
  let discountVal: number = 0;

  if (discountPercentage > 0) {
    discountType = 'percentage';
    discountVal = discountPercentage;
  }

  return {
    id: item.itemId,
    itemName: item.itemName,
    itemQuantity: item.quantity,
    brand: item.brand,
    partNumber: item.partNumber,
    sellingPrice: item.sellingPrice,
    mrp: item.originalMrp ?? item.mrp,
    hsnCode: item.hsnCode,
    gstRate: item.gstRate,
    discountType: discountType,
    discountValue: +discountVal.toFixed(2),
    // jobCardStatus: item.jobCardStatus,
    jobCardStatus: 3,
    ...(item.jobCardStatus === 2 || item.jobCardStatus === 3 ? { jobCardStatus: item.jobCardStatus } : {})
  };
});


  const labourItemsData = this.selectedLabours.map(labour => ({
    labourId: labour.labourId,
    customerQuoteId: labour.customerQuoteId || 0,
    labourName: labour.labourName,
    itmQty: labour.quantity || 1,
    labourAmount: labour.labourAmount || 0,
    jobCardStatus: labour.jobCardStatus != null ? labour.jobCardStatus : 4,
     ...(labour.jobCardStatus === 2 || labour.jobCardStatus === 3
      ? { jobCardStatus: labour.jobCardStatus }
      : { jobCardStatus: 4 })
  }));
  
  

  const cleanData1 = {
    bidId: this.item,
    garageKey: localStorage.getItem('garageKey'),
    bookingId: this.bookingId,
    items: itemsData,
    labourItems: labourItemsData,
    quoteId: this.quoteId,
    registrationNumber: this.regiNo,
    jobcardId: this.jobcardId,
    requestId: this.requestId,
    userKey: localStorage.getItem('spareUserKey'),
    quotationImages: updatedQuotationImages,
    discountType: this.discountType || null,
    discountValue: this.discountValue || 0.0,
  };

  // console.log("cleanData1----", cleanData1);

  this.aspCustomerQuoteService.submitDataUpdate(cleanData1).subscribe(
    response => {
      this.aspLoadingService.hide();
      if (response['code'] == 200) {
        this.resData = response['data'];
        this.isPopupOpen = true;
        localStorage.removeItem('activeTab');
        localStorage.removeItem('requestedQuoteItems');
      } else {
        this.toastr.error(response['message']);
      }
    },
    error => {
      this.aspLoadingService.hide();
      this.toastr.error('Failed to create quotation.');
    }
  );
}



anyItemAlreadyApprovedQuote1(){
  return this.selectedAlreadyApprovedQuotelength > 0;
}

  anyItemSelectedApprovedQuote(){
    return this.selectedItemsCountapprovedQuote > 0;
  }
  anyItemApprovedQuote(){
    return this.totalApprovedItemsCount>0;
  }
  getMakeImageUrl(make: string): string {
    if(make){
      const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
      return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
    }else {
      return
    }
  }
  totalAmount(): number {
    return this.items.filter(item => item.selected).reduce((total, item) => total + item.price, 0);
  }
  totalAmountQuote(): number {
    return this.items.filter(quote => quote.selected).reduce((total, item) => total + item.price, 0);
  }
  toggleSelectAllQuote(): void {
    this.selectAllQuote = !this.selectAllQuote;
    this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
    this.selectedItemsLabourQuote.forEach(quote=> quote.selected =this.selectAllQuote);
    // console.log("this.selected Labours---",this.selectedItemsLabourQuote);
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
  // toggleIndividualQuote(quote: any): void {
  //   quote.selected = !quote.selected;
  
  //   // If any checkbox is unchecked, unselect "Select All"
  //   this.selectAllQuote = this.customerQuotation.every(q => q.selected) && this.selectedItemsLabourQuote.every(q => q.selected);
  
  //   // Update calculations
  //   this.updateSelectedItemsQuote();
  //   this.updateSelectedLabourItems();
  // }
  
  calculateMRP(item: any): number {
    this.customerQuotation.forEach
    return (item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity;
  }
  calculateTotalMRP(): void {
    this.totalMRP = this.items.reduce((total, item) => {
      return total + this.calculateMRP(item);
    }, 0);
  }

  toggleItemEditSelectionQuote(): void {
    const allSparesSelected = Array.isArray(this.customerQuotation) && this.customerQuotation.every(quote => quote.selected);
    const allLaboursSelected = Array.isArray(this.selectedItemsLabourQuote) && this.selectedItemsLabourQuote.every(labour => labour.selected);
    this.selectAllQuote = allSparesSelected && allLaboursSelected;
    this.selectedLabourCount = Array.isArray(this.selectedItemsLabourQuote)
      ? this.selectedItemsLabourQuote.filter(labour => labour.selected).length
      : 0;
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.cdr.detectChanges();
  }

  toggleItemApproveSelectionQuote(): void {
    const allSparesSelected = Array.isArray(this.customerQuotation) && this.customerQuotation.every(quote => quote.selected);
    const allLaboursSelected = Array.isArray(this.selectedItemsLabourQuote) && this.selectedItemsLabourQuote.every(labour => labour.selected);
    this.selectAllQuote = allSparesSelected && allLaboursSelected;
    this.selectedLabourCount = Array.isArray(this.selectedItemsLabourQuote)
      ? this.selectedItemsLabourQuote.filter(labour => labour.selected).length
      : 0;
      // console.log("allSparesSelected---",allSparesSelected);
      // console.log("selectedLabourCount----",this.selectedLabourCount);
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.cdr.detectChanges();
  }
  toggleItemViewApproveSelectionQuote(): void {
    const allSparesSelected = Array.isArray(this.customerQuotation1) && this.customerQuotation1.every(quote => quote.selected);
    const allLaboursSelected = Array.isArray(this.selectedItemsLabour) && this.selectedItemsLabour.every(labour => labour.selected);
    this.selectAllQuote = allSparesSelected && allLaboursSelected;
    this.selectedLabourCount = Array.isArray(this.selectedItemsLabour)
      ? this.selectedItemsLabour.filter(labour => labour.selected).length
      : 0;
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.cdr.detectChanges();
  }
  


  toggleItemSelectionQuote(): void {
    if (Array.isArray(this.customerQuotation)) {
      this.selectAllQuote = this.customerQuotation.every(quote => quote.selected);
    } else {
      this.selectAllQuote = false;
    }
    //  // if (Array.isArray(this.customerQuotation1))
    //  if (Array.isArray(this.customerQuotation1)) {alert("items")
    //   this.customerQuotation1.forEach(quote => {
    //     quote.selected = this.selectAllQuote;
    //   });
    // } else {
    //   this.selectAllQuote = false;  
    //  }
  
    if (Array.isArray(this.selectedItemsLabourQuote)) {
      this.selectedItemsLabourQuote.forEach(labour => {
        labour.selected = labour.selected ? true : false;
        
      });

  
      this.selectedLabourCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
    }
     else {
      this.selectedLabourCount = 0;
    }

    
  
    // Ensure selectedItemsLabourQuote is updated
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  
    // Force UI update
    this.cdr.detectChanges();
  }
  hasPendingQuotes(): void {
  this.customerQuotation1?.some(item => item.quoteItemStatus === 2);
}


  toggleItemviewSelectionQuote(item, type) {
    if (type === 'view') {
      if (Array.isArray(this.customerQuotation1)) {
        let allSelected = true;
        this.customerQuotation1.forEach(quote => {
          if (quote === item) {
            quote.selected = !quote.selected; // Toggle the selected item
          }
          if (!quote.selected) {
            allSelected = false; // Check if all are selected
          }
        });
        this.selectAllQuote = allSelected;
      } else {
        // console.log('error: select all quotes');
      }
    } else if (type === 'view') {
      if (Array.isArray(this.selectedItemsLabour)) {
        let allSelected = true;
        this.selectedItemsLabour.forEach(labour => {
          if (labour === item) {
            labour.selected = !labour.selected; // Toggle the selected item
          }
          if (!labour.selected) {
            allSelected = false; // Check if all are selected
          }
        });
        this.selectAllQuote = allSelected;
      } else {
        // console.log('error: select all labour');
      }
    }
  
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
  

  
  openEditDialog(itemQuotes){
    // console.log("itemsquote0--",itemQuotes)
    // console.log("this.customerQuotation",this.customerQuotation);
    
    this.itemQuote = [];
    this.itemQuote=itemQuotes;
    this.itemQuote.discountedPrice = this.calculateDiscountedPrice(itemQuotes.sellingPrice, itemQuotes.discount);
    this.isPopupOpenEdit = true;
    this.selectedItemsCountQuote = 0;
    this.customerQuotation.forEach(quote => {
      quote.selected = false;
    });
    this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote=false);
  }


  calculateDiscountedPrice(mrp: number, discount: number): number {
    return mrp - (mrp * discount / 100);
  }
  save(): void {
    // console.log("this.itemquote--",this.customerQuotation);
    
    const index = this.customerQuotation.findIndex(i => i.name === i.itemName);
    // console.log("index---", index);
    
    if (index !== -1) {  // Correct condition
      this.customerQuotation[index].mrp = Number(this.itemQuote.mrp);
      this.customerQuotation[index].totalAmount = Number(this.itemQuote.mrp) * this.itemQuote.itemQuantity;
        }
      this.customerQuotation = [...this.customerQuotation];  // Create a new reference

    
    // Recalculate the total quotation price
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();

    this.updateSelectedItemsQuote();
    this.getQuoteGrandTotal();
    this.closePopupEdit();

}
closePopupEdit(): void {
  this.isPopupOpenEdit = false;
}
calculateTotalQuotationPrice(): number {
  // Recalculate total price by summing up all items' total amounts
  return this.customerQuotation.reduce((sum, item) => sum + (item.mrp * item.itemQuantity), 0);
}

createNewItems(){
  this.newItem=!this.newItem;
}
createItemSidebar(){
  this.newItem= false;
  this.newItems=!this.newItems;
}
onSubmit() {
     if (this.itemForm.invalid) {
    Object.keys(this.itemForm.controls).forEach(field => {
      const control = this.itemForm.get(field);
      control?.markAsTouched({ onlySelf: true });
      control?.updateValueAndValidity(); // Ensure validation messages appear
    });

    this.scrollToFirstInvalidField();
    return;
  }

  // console.log('Form submitted successfully', this.itemForm.value);

  if (this.itemForm.valid) {
    // console.log('Form Submitted createNewItem', this.itemForm.value);
    const cleanData1 = {
      "garageKey": localStorage.getItem('garageKey'),
      "garageName": localStorage.getItem('spareSelectedGarageName'),
      "userName": localStorage.getItem('spareSelectedGarageName'),
      "userRole":localStorage.getItem('userType'),
      "partName": this.itemForm.value['itemName'],
      "partNumber":this.itemForm.value['partNumber'],
      "mrp": (this.itemForm.value.unitPrice / 100).toFixed(2),
      "gstRate": this.itemForm.value['gst'],
      "brandName":this.itemForm.value['brand'],
      "hsnCode": this.itemForm.value['hsn'],
      "make": this.request?.jobCard?.make,
      "model": this.request?.jobCard?.model,
      "variant":this.request?.jobCard?.variant,
      "rowKey": this.request?.jobCard?.rowKey,
      "variantKey": this.request?.jobCard?.variantKey
    };
  
    // Call the API with updated data
    this.aspCustomerQuoteService.createNewItem(cleanData1).subscribe(response => {
      const res = JSON.parse(JSON.stringify(response));
      // console.log("res123456789",res);
      this.originalData=res.data;
      const transformedData = {
        ...this.originalData, 
        brand:this.originalData.brandName,
        itemName: this.originalData.partName, 
        itemId: undefined, 
        quantity: 1,
        mrp : this.originalData.mrp
      };
      this.editCustomerQuotation.push(transformedData);
      // console.log("transformed Data---",transformedData);
      // console.log("this.customerQuotation",this.customerQuotation);
      this.customerQuotationListCount = this.editCustomerQuotation.length
      // console.log('Item added successfully:', this.customerQuotationListCount);
   
      this.editCustomerQuotation.forEach(quote => quote.selected = this.selectAllQuote);  

      this.addEditItemToQuotation(transformedData);
      this.customerQuotationCount=this.editCustomerQuotation.length;
      this.isSidebarOpen = false;
      this.clearSearch();
      // this.updateSelectedEditItemsQuote();
      this.updateSelectedEditItemsQuote();
      this.updateEditSelectedLabourItems();
      this.getQuoteGrandTotal();
      this.itemForm.reset();
     
      
    }
  )
  }
  this.newItems=false;
}
scrollToFirstInvalidField() {
  const firstInvalidControl: HTMLElement = document.querySelector(
    ".ng-invalid.ng-touched"
  ) as HTMLElement;

  if (firstInvalidControl) {
    firstInvalidControl.scrollIntoView({ behavior: "smooth", block: "center" });
    firstInvalidControl.focus(); // Optional: Focus on the field
  }
}

// openPopup(): void {
//   this.isPopupOpen = true;
//   this.CloseSidebarQuote();
//   this.submitData(); 
// }

// closePopup(): void {
//   this.isPopupOpen = false;
// }

shareForApproval(): void {
  let garageName = localStorage.getItem('spareSelectedGarageName');
  
  let garageKey = localStorage.getItem('garageKey');
  const userKey = localStorage.getItem('spareUserKey');
  const combinedPath = `${this.quoteId}/${this.jobcardId}/${garageKey}/${userKey}`;
  const encodedPath = btoa(combinedPath);
  // const message = `*Approval Needed for Your Spare Parts Quotation*\n\n`+
  // `Dear Customer\n\n`+
  // `We've prepared the spare parts quotation for your car's repair. 🚗\n`+
  // `Please review and approve it at your earliest convenience by clicking the link below:\n\n`+
  // `👉 ${GlobalVariable.AUTOVERSE_WEB}/quote-details/${encodedPath} \n\n`+
  // `Your prompt approval will help us speed up the repair process. 🛠\n\n`+
  // `Thank you for choosing `+garageName+`. We value your trust in us!\n\n`+
  // `Best Regards,\n`+
  // `*`+garageName+`*`;

  // WhatsApp API or Intent to share
  // window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  // window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
   const carDetails = `${this.data?.make} ${this.data?.model} - ${this.data?.fuelType} - ${this.data?.variant} - ${this.data?.year}`;
const messageLink = `/quote-details/${encodedPath}`;
    const messagePayload = {
    v1: garageName,                        // garage name
    v2: String(this.quoteId),                                   // job card id
    v3: carDetails,                                   
    v4: this.data?.registrationNumber,               
    v5: '', 
    id: messageLink,
    to: ''                      
  };

  // Send via WhatsApp API
  this.aspCheckinReportsService.sendWhatsAppMessage('quatationApproval', messagePayload).subscribe(
    res => {
      // console.log('WhatsApp message sent', res);

      this.closeMenu();
    },
    err => {
      console.error('Failed to send WhatsApp message', err);
    }
  );
}


onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const files: FileList = input.files;

    // ✅ Ensure arrays exist
    this.updatedImages = Array.isArray(this.updatedImages) ? this.updatedImages : [];
    this.quotationImages = Array.isArray(this.quotationImages) ? this.quotationImages : [];

    Array.from(files).forEach((file) => {
      this.s3ImageUploadService.getPresignedUrl(file.name).subscribe({
        next: (response) => {
          const presignedUrl = response[0]?.signedUrl;
          const link = response[0]?.link;

          if (presignedUrl && link) {
            this.uploadFileToS3(presignedUrl, file);

            // ✅ Determine next available tag number
            let tagNumber = 1;
            const existingTags = this.quotationImages.map(img => img.tag);

            while (existingTags.includes(`Spare Part ${tagNumber}`)) {
              tagNumber++;
            }

            // ✅ Create image object with unique tag
            const imageData = { 
              url: link, 
              tag: `Spare Part ${tagNumber}` 
            };

            // console.log("Adding new image:", imageData);


            // ✅ Append to both lists correctly
            this.updatedImages.push(imageData);
            this.quotationImages.push(imageData); 

            // console.log("Updated images list:", this.updatedImages);
            // console.log("Final quotationImages:", this.quotationImages);
          } else {
            console.error('Invalid presigned URL:', response);
          }
        },
        error: (err) => console.error('Error fetching presigned URL:', err),
      });
    });
  }
}


uploadFileToS3(presignedUrl,file): void {
  // console.log("file--",file)
  // console.log('Presigned URL:', presignedUrl);
  const contentType = file.type;
  // console.log("file.type--",file.type);
  this.http.put(presignedUrl,file, {
    headers: { 'Content-Type': contentType },
  }).subscribe({
    next: () => {
      // console.log('File uploaded successfully.');
    },
    error: (err) => {
      console.error('Error uploading file:', err);
    },
    complete: () => {
      this.loading = false;
      this.aspLoadingService.hide();
    },
  });
}
openImage(imagePath: string): void {
  if (imagePath) {
    window.open(imagePath, '_blank');
  } else {
    this.toastr.error('Image is Not Valid');
  }
}
closeViewer(): void {
  this.isViewerOpen = false;
}
openViewer(index: number): void {
  this.currentIndex = index;
  this.selectedImage = this.quotationImages[this.currentIndex].url; // Correctly accessing URL
  this.isViewerOpen = true;
}
prevImage1(): void {
  if (this.currentIndex > 0) {
    this.currentIndex--;
    this.selectedImage = this.quotationImages[this.currentIndex].url;
  }
}

nextImage1(): void {
  if (this.currentIndex < this.quotationImages.length - 1) {
    this.currentIndex++;
    this.selectedImage = this.quotationImages[this.currentIndex].url;
  }
}

deleteImage(index: number): void {
  if (index > -1) {
    // Remove the selected image from quotationImages
    this.quotationImages.splice(index, 1);

    // Store remaining images in updateImage
    // this.deleteUpdatedImage = [...this.quotationImages];
    // this.quotationImages = [...this.quotationImages];
    
    // Close viewer if the deleted image was being viewed
    // if (this.currentIndex === index) {
    //   this.isViewerOpen = false;
    // } else if (this.currentIndex > index) {
    //   this.currentIndex--;
    // }

    // Update selectedImage after deletion
    // if (this.updatedImages.length > 0) {
    //   this.selectedImage = this.updatedImages[this.currentIndex]?.url || '';
    // } else {
    //   this.selectedImage = '';
    // }
  }
  // console.log("Updated Images:", this.updatedImages);
  // console.log("updateImage:", this.deleteUpdatedImage);
}
@HostListener('document:keydown', ['$event'])
handleKeyboardEvent(event: KeyboardEvent): void {
  if (!this.isViewerOpen) return;

  if (event.key === 'ArrowLeft') {
    this.prevImage1();
  } else if (event.key === 'ArrowRight') {
    this.nextImage1();
  } else if (event.key === 'Escape') {
    this.closeViewer();
  }
}


// =============================== EXTRA DISCOUNT-BOTTOM-SHEET=======================

openExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = true;
}

closeExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = false;
}

setDiscountType(type: 'rupees' | 'percentage') {
  this.discountType = type;
}

saveExtraDiscount() {
  if (this.discountType === 'rupees') {
    this.calculatedDiscount = this.discountValue;
  } else {
    this.calculatedDiscount = (this.totalSelectedEditPriceQuote * this.discountValue) / 100;
  }
    this.showExtraDiscountBottomSheet = false;
}
saveViewExtraDiscount() {
  if (this.discountType === 'rupees') {
    this.calculatedDiscount = this.discountValue;
  } else {
    this.calculatedDiscount = (this.selectedAlreadyApprovedQuote * this.discountValue) / 100;
  }
    this.showExtraDiscountBottomSheet = false;
}

approveSaveExtraDiscount() {
  if (this.discountType === 'rupees') {
    this.calculatedDiscount = this.discountValue;
  } else {
    this.calculatedDiscount = (this.totalSelectedApprovedriceQuote * this.discountValue) / 100;
  }
this.showExtraDiscountBottomSheet = false;
}

toggleInfoPopup() {
  this.showInfoPopup = !this.showInfoPopup;
}
getDiscountAmount(): number {
  if (!this.totalSelectedEditPriceQuote) return 0;
  if (this.discountType === 'rupees') 
  {
    return this.discountValue;
  } else {
    return (this.discountValue / 100) * this.totalSelectedEditPriceQuote;
  }
}
getViewDiscountAmount(): number {
  if (!this.selectedAlreadyApprovedQuote) return 0;
  if (this.discountType === 'rupees') {
    return this.discountValue;
  } else {
    return (this.discountValue / 100) * this.selectedAlreadyApprovedQuote;
  }
}
getViewDiscountPercentage(): number {
  if (!this.selectedAlreadyApprovedQuote || this.selectedAlreadyApprovedQuote === 0) return 0;
  if (this.discountType === 'percentage') {
    return this.discountValue;
  } else {
    return (this.discountValue / this.selectedAlreadyApprovedQuote) * 100;
  }
}

getDiscountPercentage(): number {
  // console.log("totla amount of view quotation----",this.totalSelectedEditPriceQuote);
  // console.log("this.discount value of view quotation---",this.discountValue);
  if (!this.totalSelectedEditPriceQuote || this.totalSelectedEditPriceQuote === 0) return 0;
  if (this.discountType === 'percentage') {
    return this.discountValue;
  } else {
    return (this.discountValue / this.totalSelectedEditPriceQuote) * 100;
  }
}

calculateViewDiscountPreview(index: number) {
  const totalAmount = this.selectedAlreadyApprovedQuote;
  // console.log(" this.selectedAlreadyApprovedQuote---", this.selectedAlreadyApprovedQuote);
  // console.log("this.customer without Index------", totalAmount);
  // console.log("this.totalAmount-----", this.customerQuotation[index]);
  this.isDiscountInvalid = false;
  if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
  (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
    this.isDiscountInvalid = true;
    }
  if (this.discountType === 'rupees') {
    this.discountInRupees = this.discountValue || 0;
    this.discountInPercent = totalAmount
      ? (this.discountInRupees / totalAmount) * 100
      : 0;
  } else {
    this.discountInPercent = this.discountValue || 0;
    this.discountInRupees = totalAmount
      ? (this.discountInPercent / 100) * totalAmount
      : 0;
  }
}

calculateDiscountPreview(index: number) {
  const totalAmount = this.totalSelectedEditPriceQuote || 0;
  // console.log("this.customer without Index------", this.totalAmount);
  // console.log("this.totalAmount-----", this.customerQuotation[index]);
  this.isDiscountInvalid = false;
  if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
  (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
this.isDiscountInvalid = true;
}


  if (this.discountType === 'rupees') 
  {
    this.discountInRupees = this.discountValue || 0;
    this.discountInPercent = totalAmount
      ? (this.discountInRupees / totalAmount) * 100
      : 0;
  } else 
  {
    this.discountInPercent = this.discountValue || 0;
    this.discountInRupees = totalAmount
      ? (this.discountInPercent / 100) * totalAmount
      : 0;
  }
}


approveGetDiscountAmount(): number {
  const totalAmount = this.totalSelectedApprovedriceQuote || 0;
  if (!this.totalSelectedApprovedriceQuote) return 0;
    // Check if discountValue is greater than totalAmount
    this.isDiscountInvalid = false;
    if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
    (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
  this.isDiscountInvalid = true;
  }
  if (this.discountType === 'rupees') {
    return this.discountValue;
  } else {
    return (this.discountValue / 100) * this.totalSelectedApprovedriceQuote;
  }
}



approveGetDiscountPercentage(): number {
  if (!this.totalSelectedApprovedriceQuote) return 0;
  if (this.discountType === 'percentage') {
    return this.discountValue;
  } else {
    return (this.discountValue / this.totalSelectedApprovedriceQuote) * 100;
  }
}
approveCalculateDiscountPreview(index: number) {
  const totalAmount = this.customerQuotation[index]?.totalAmount || 0;
  // console.log("this.customer eithout Index------",this.customerQuotation);
  // console.log("this.totalAmount-----",this.customerQuotation[index])

  if (this.discountType === 'rupees') {
    this.discountInRupees = this.discountValue || 0;
    this.discountInPercent = totalAmount
      ? (this.discountInRupees / totalAmount) * 100
      : 0;
  } else {
    this.discountInPercent = this.discountValue || 0;
    this.discountInRupees = totalAmount
      ? (this.discountInPercent / 100) * totalAmount
      : 0;
  }
}
  // =============================== EXTRA DISCOUNT-BOTTOM-SHEET-END=======================

  viewGetDiscountAmount(){
    const totalAmount = this.selectedAlreadyApprovedQuote || 0;
    if (!this.selectedAlreadyApprovedQuote) return 0;
      // Check if discountValue is greater than totalAmount
      this.isDiscountInvalid = false;
      if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
      (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
    this.isDiscountInvalid = true;
    }
    if (this.discountType === 'rupees') {
      return this.discountValue;
    } else {
      return (this.discountValue / 100) * this.selectedAlreadyApprovedQuote;
    }
  }
  viewGetDiscountPercentage(): number {
    if (!this.selectedAlreadyApprovedQuote) return 0;
    if (this.discountType === 'percentage') {
      return this.discountValue;
    } else {
      return (this.discountValue / this.selectedAlreadyApprovedQuote) * 100;
    }
  }
  viewCalculateDiscountPreview(index: number) {
    const totalAmount = this.customerQuotation[index]?.totalAmount || 0;
    // console.log("this.customer eithout Index------",this.customerQuotation);
    // console.log("this.totalAmount-----",this.customerQuotation[index])
    if (this.discountType === 'rupees') {
      this.discountInRupees = this.discountValue || 0;
      this.discountInPercent = totalAmount
        ? (this.discountInRupees / totalAmount) * 100
        : 0;
    } else {
      this.discountInPercent = this.discountValue || 0;
      this.discountInRupees = totalAmount
        ? (this.discountInPercent / 100) * totalAmount
        : 0;
    }
  }
  // =========================BELOW CODE IS FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================
  toggleTopSearchBar() {
  this.searchActive = !this.searchActive;
   this.searchText = '';
  this.suggestions = [];

  // Reset form only if search is being closed
  if (!this.searchActive) {
    this.itemForm.reset(); // Clear all auto-filled form fields
  }
}


    isFirstSuggestion(suggestion: string, index: number): boolean {
        // Check if it's the first suggestion and if it matches preSearchValue
        let preSearchValue=localStorage.getItem('preSearchValue');
        return index === 0 && preSearchValue === suggestion['value'];
    }
    sortSuggestionsByRelevance(suggestions: { value: string, type: string }[], searchText: string): { value: string, type: string }[] {
    const typePriority = {
        brand: 4,
        category: 3,
        partName: 2,
        partNumber: 1,
    };

    return suggestions?.sort((a, b) => {
        const relevanceA = this.getRelevance(a.value, searchText) + typePriority[a.type];
        const relevanceB = this.getRelevance(b.value, searchText) + typePriority[b.type];

        return relevanceB - relevanceA; 
    });
}
getRelevance(suggestion: string, searchText: string): number {
    if (suggestion?.toLowerCase() === searchText?.toLowerCase()) {
        return 3; 
    } else if (suggestion?.toLowerCase().startsWith(searchText?.toLowerCase())) {
        return 2; 
    } else if (suggestion?.toLowerCase().includes(searchText?.toLowerCase())) {
        return 1; 
    } else {
        return 0; 
    }
}
 private clearLocalStorage(){
        sessionStorage.removeItem('sparePartsDetails');
        localStorage.removeItem('vehicleType');
        // localStorage.removeItem('newMake');
        // localStorage.removeItem('newModel');
        // localStorage.removeItem('newYear');
        // localStorage.removeItem('newVariant');
        // localStorage.removeItem('newVariantKey');
        // localStorage.removeItem('newRowKey');
        localStorage.removeItem('isShippingCharges');
        localStorage.removeItem('prepayUpiDiscount');
        // localStorage.removeItem('vehicleData');
        // localStorage.removeItem('selectedModel');
        // localStorage.removeItem('selectedYear');
        // localStorage.removeItem('variant');
        // localStorage.removeItem('selectedFuel');
        // localStorage.removeItem('variantKey');
        // localStorage.removeItem('rowKey');
        localStorage.removeItem('selectedSparesList');
        localStorage.removeItem('preSearchValue');
    };
         toggleSearch() {
          this.isSearchOpen = !this.isSearchOpen;
        this.isInputVisible = !this.isInputVisible;
        if (this.isInputVisible) {
          setTimeout(() => {
            const input = document.querySelector('.SearchInput') as HTMLInputElement;
            if (input) {
              input.focus();
            }
          }, 0);
        }
      }
      onPartNumberClick(partNumber: string): void {
  this.searchText = partNumber;
  this.filterSuggestions();
}

filterSuggestions(): void {
  // console.log('Filtering for:', this.searchText);
  if (this.searchText && this.searchText.length >= 3) {
    const rowKey = localStorage.getItem('rowKey');
    const variantKey = localStorage.getItem('variantKey');
    const universal = false;

    this.searchSuggestionService.getSearchSuggestions(rowKey, this.searchText, universal, variantKey)
      .subscribe((result: any) => {
        // console.log('API response:', result);
        this.suggestions = [];

        if (result?.data?.brands?.length)
          this.suggestions.push(...result.data.brands.map((value: string) => ({ value, type: 'brand' })));

        if (result?.data?.categories?.length)
          this.suggestions.push(...result.data.categories.map((value: string) => ({ value, type: 'category' })));

        if (result?.data?.partNames?.length)
          this.suggestions.push(...result.data.partNames.map((value: string) => ({ value, type: 'partName' })));

        if (result?.data?.partNumbers?.length)
          this.suggestions.push(...result.data.partNumbers.map((value: string) => ({ value, type: 'partNumber' })));

        // console.log('Suggestions after parsing:', this.suggestions);

        this.suggestions.reverse();
        this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);
      });
  } else {
    this.suggestions = [];
  }
}

selectSuggestion(suggestion: { value: string; type: string }): void {
  this.searchText = suggestion.value;
  this.suggestions = [];

  // If needed, you can do something based on type:
  if (suggestion.type === 'partNumber') {
    // Load item or navigate
    // console.log('Selected Part Number:', suggestion.value);
  }
}
onPartSelected(partNumber: string) {
  if (!partNumber) return;

  // Set input box to selected part number
  this.searchText = partNumber;

  this.suggestions = [];

  let garageKey = localStorage.getItem('garageKey');
  this.aspProductDetailsService.productDetails(garageKey, 'part-number', partNumber).subscribe({
    next: (res: any) => {
      if (res.code === 200 && res.data) {
        const product = res.data;
        // console.log("product----",product)

        this.itemForm.patchValue({
          itemName: product.name || '',
          partNumber: product.partNumber || '',
          brand: product.brand?.name || '',
          unitPrice: product.sellingPrice || product.mrp || '',
           hsn: product.hsnCode || '',  
          // gst:product.gstRate * 100 || '',
        });
        //  Convert gstRate decimal to percentage and assign to selectedGst

        this.selectedGst = product.gstRate ? Math.round(product.gstRate * 100) : null;
        this.addEditItemToQuotation(product);
      } else {
        this.toastr.error('Item details not found.');
      }
    },
    error: (err) => {
      console.error('Error fetching product details:', err);
      this.toastr.error('Item details not found.');
    }
  });
}

onItemNameInput(value: string) {
  clearTimeout(this.searchTimeout);

  if (value && value.length >= 2) {
    this.searchTimeout = setTimeout(() => {
      this.myJobCardsDetailsService.searchB2BLineItem(value).subscribe((res: any) => {
        this.itemSuggestions = res?.response?.body?.items || [];
        this.showSuggestionList = true;
      });
    }, 300);  // debounce time
  } else {
    this.itemSuggestions = [];
    this.showSuggestionList = false;
  }
}

selectItem(item: any) {
  this.itemForm.patchValue({ itemName: item.name });
  this.showSuggestionList = false;
  // console.log('Selected item:', item);
}

// hideSuggestions() {
//   setTimeout(() => {
//     this.showSuggestionList = false;
//   }, 200);
// }

showSuggestions() {
  if (this.itemSuggestions.length > 0) {
    this.showSuggestionList = true;
  }
}
  // =========================END OF CODE  FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================
  // ============item level discount====================
calculateItemDiscountPreview(index: number): void {
  const quote = this.editCustomerQuotation?.[index];
  const formGroup = this.quoteFormArray?.at(index) as FormGroup;

  if (!quote || !formGroup) {
    console.warn(`Missing quote or form group at index: ${index}`);
    return;
  }

  const discountValue = Number(formGroup.get('discountValue')?.value || 0);
  const discountPercentage = Number(formGroup.get('discountPercentage')?.value || 0);
  const totalMrp = quote.mrp * (quote.quantity || 1);

  // Reset validation flag
  quote.isDiscountInvalid = false;

  // Validation checks
  if (discountValue > totalMrp || discountPercentage > 100) {
    quote.isDiscountInvalid = true;
  }

  // Calculate rupees and percent for preview
  quote.discountInRupees = discountValue || (discountPercentage / 100) * totalMrp;
  quote.discountInPercent = discountPercentage || (discountValue / totalMrp) * 100;
}

getControlValue(i: number, controlName: string): any {
  return this.quoteFormArray.at(i)?.get(controlName)?.value;
}

    updateItemTotal(index: number) {
      const discount = this.quoteFormArray.at(index).value;
      this.recalculateMrpWithDiscount(index, discount);
      this.updateSelectedEditItemsQuote();
    }

// recalculateMrpWithDiscount(index: number, discount: { discountValue: number, discountPercentage: number }) {
//   const item = this.editCustomerQuotation[index];
//   const originalMrp = item.originalMrp ?? item.mrp;

//   // If percentage discount entered
//   if (discount.discountPercentage != null && discount.discountPercentage > 0) {
//     item.discountValue = discount.discountPercentage;
//     item.discountType = 'percentage';
//   }

//   // If flat discount entered
//   else if (discount.discountValue != null && discount.discountValue > 0) {
//     item.discountValue = discount.discountValue;
//     item.discountType = 'rupees';
//   }

//   // If both are cleared or zero, remove discount
//   else {
//     item.discountValue = 0;
//     item.discountType = null;
//   }

//   // Force re-render by cloning array
//   this.editCustomerQuotation = [...this.editCustomerQuotation];
// }

recalculateMrpWithDiscount(index: number, discount: { discountValue: any, discountPercentage: number }) {
  const item = this.editCustomerQuotation[index];
  // console.log("edit item quotation of meghana------",this.editCustomerQuotation);
  const originalMrp = item.originalMrp ?? item.mrp ?? 0;

  const qty = item.quantity || 1;
  const totalMrp = originalMrp*qty;

  item.isDiscountInvalid = false;

  if (discount.discountPercentage != null && discount.discountPercentage > 0) {
    if (discount.discountPercentage > 100) {
      item.isDiscountInvalid = true;
      return;
    }

    item.discountValue = discount.discountPercentage;
    item.discountType = 'percentage';

    const discountedTotal = totalMrp * (1 - discount.discountPercentage / 100);
    item.sellingPrice = (discountedTotal / qty).toFixed(2);  // ✅ Per-item price
  } else if (discount.discountValue != null && discount.discountValue > 0) {
    if (discount.discountValue > totalMrp) {
      item.isDiscountInvalid = true;
      return;
    }

    item.discountValue = discount.discountValue;
    item.discountType = 'rupees';

    const discountedTotal = totalMrp - discount.discountValue;
    item.sellingPrice = (discountedTotal).toFixed(2); 
  } else {
    item.discountValue = 0;
    item.discountType = null;
    item.sellingPrice = originalMrp;
  }

  this.editCustomerQuotation[index] = { ...item };
  this.editCustomerQuotation = [...this.editCustomerQuotation];
  // console.log("this.second edit item quotation",this.editCustomerQuotation )
}



onDiscountValueInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as FormGroup;
  const value = +control.get('discountValue')?.value || 0;

  // Clear percentage field
  control.get('discountPercentage')?.setValue(0, { emitEvent: false });

  const item = this.editCustomerQuotation[i];
  const mrp = (+item.mrp || 0)* (item.quantity);
  const originalMrp = item.originalMrp ?? item.mrp ?? 0;

  // Calculate percentage from value
  let discountPercentage = mrp > 0 ? (value / mrp) * 100 : 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  control.get('discountPercentage')?.setValue(discountPercentage, { emitEvent: false });

  item.discountValue = Math.round(value); // round off to nearest integer
  item.discountType = value > 0 ? 'rupees' : null;
  item.isDiscountInvalid = value > mrp;

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue: item.discountValue,
      discountPercentage,
    });
  }
}



onDiscountPercentageInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as FormGroup;
  let discountPercentage = +control.get('discountPercentage')?.value || 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  const item = this.editCustomerQuotation[i];
  const mrp = (+item.mrp || 0) * (item.quantity);
  let discountValue = discountPercentage > 0 ? (mrp * discountPercentage) / 100 : 0;
  discountValue = Math.round(discountValue); // round to nearest integer

  control.get('discountValue')?.setValue(discountValue, { emitEvent: false });

  item.discountValue = discountValue;
  item.discountType = discountPercentage > 0 ? 'percentage' : null;
  item.isDiscountInvalid = discountPercentage > 100;

  // console.log("onDiscountPercentageInput edit quotation:", this.editCustomerQuotation);

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue,
      discountPercentage,
    });
  }
}




// onDiscountPercentageInput(i: number) {
//   const discountPercentage = +this.mainForm.get(['quoteFormArray', i, 'discountPercentage'])?.value || 0;

//   // Update form logic
//   this.mainForm.get(['quoteFormArray', i, 'discountValue'])?.setValue(0, { emitEvent: false });

//   // ✅ Update item for rendering
//   const item = this.editCustomerQuotation[i];
//   item.discountValue = discountPercentage;
//   item.discountType = discountPercentage > 0 ? 'percentage' : null;

//   this.recalculateMrpWithDiscount(i, { discountValue: 0, discountPercentage });
// }

getDiscountedMrp(quote: any): number {
  if (!quote || !quote.originalMrp || !quote.quantity) return 0;

  if (quote.discountValue > 0) {
    if (quote.discountType === 'percentage') {
      return quote.originalMrp * quote.quantity * (1 - quote.discountValue / 100);
    } else if (quote.discountType === 'rupees') {
      return (quote.originalMrp - quote.discountValue) * quote.quantity;
    }
  }

  return quote.originalMrp * quote.quantity;
}


// onDiscountPercentageInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   const discountPercentage = +group.get('discountPercentage')?.value || 0;
  // console.log('Discount percentage input:', discountPercentage, 'at index:', index);

//   if (discountPercentage > 0) {
//     group.patchValue({ discountValue: 0 }, { emitEvent: false });
//   }

//   // ✅ Update your quotation object directly
//   this.editCustomerQuotation[index].discountPercentage = discountPercentage;
//   this.editCustomerQuotation[index].discountValue = 0;

//   this.calculateItemDiscountPreview(index);

//   const discount = {
//     discountValue: 0,
//     discountPercentage
//   };
//   this.recalculateMrpWithDiscount(index, discount);
// }

closePage(){
      this.location.back();
}
}
